<template>
  <div class="pt-3 pl-4 container-calendar">
    <div
      id="scheduled-event-calendar-view"
      class="d-flex flex-row justify-content-start align-items-start"
    >
      <div class="side-bar-content h-100 p-1">
        <div class="filter-container-inner">
          <div class="calendar-container">
            <b-calendar v-model="date" hide-header locale="en-US" width="225px">
            </b-calendar>
            <div style="padding-right: 25px">
              <b-btn
                variant="outline-primary"
                size="sm"
                class="mt-1 mb-1"
                block
                @click="date = formatDateOnlyMysql()"
                >Today</b-btn
              >
            </div>
          </div>
          <hr class="divider" />
          <div class="ml--10 pb-2 d-flex align-items-center">
            <vue-toggles
              v-if="currentUser && !currentUser.onlyAccessAssignedPatients"
              @click="changeAssignedToMEToggle()"
              :value="assignedToMe"
              height="20"
              width="30"
              checkedBg="#34C759"
              uncheckedBg="#FF6161"
            />
            <small
              v-if="currentUser && !currentUser.onlyAccessAssignedPatients"
              class="ml-2"
              >Show My Patients only</small
            >
          </div>
          <div class="sidebar-filters-container">
            <div class="mr-3">
              <b-form-group label="Providers">
                <div class="small-selector">
                  <v-select
                    :options="providerUsers"
                    v-model="filter.users"
                    placeholder="Search..."
                  />
                </div>
              </b-form-group>
            </div>
            <hr class="divider" />
            <div class="mr-3">
              <b-form-group label="Facilitators">
                <div class="small-selector">
                  <multiple-select-sidebar-filter
                    :options="providerFacilitators"
                    v-model="filter.facilitators"
                    :fullWidth="true"
                    placeholder="Search..."
                    :infiniteList="true"
                  />
                </div>
              </b-form-group>
            </div>
            <hr class="divider" />
            <div class="mr-3">
              <b-form-group label="Place of Service">
                <div class="small-selector">
                  <multiple-select-sidebar-filter
                    :options="providersPlacesOfService"
                    v-model="filter.placeOfService"
                    :fullWidth="true"
                    placeholder="Search..."
                    :infiniteList="true"
                  />
                </div>
              </b-form-group>
            </div>
            <hr class="divider" />
            <div class="mr-3">
              <b-form-group label="Status">
                <div>
                  <b-form-checkbox-group
                    v-model="filter.status"
                    name="event-type"
                    size="lg"
                  >
                    <div
                      class="event-type-item"
                      v-for="statusItem in statuses"
                      :key="statusItem.value"
                    >
                      <div class="event-type-label position-relative">
                        <div
                          class="box-color"
                          :style="{
                            backgroundColor: statusItem.data.color
                              ? statusItem.data.color
                              : '#000000'
                          }"
                        ></div>
                        <label class="event-type-label-item">{{
                          statusItem.label
                        }}</label>
                      </div>
                      <b-form-checkbox class="mb-1" :value="statusItem.value">
                      </b-form-checkbox>
                    </div>
                  </b-form-checkbox-group>
                </div>
              </b-form-group>
            </div>
            <hr class="divider" />
            <div class="mr-3">
              <b-form-group label="Documentation Status">
                <div>
                  <b-form-checkbox-group
                    v-model="filter.documentationStatus"
                    name="event-type"
                    size="lg"
                  >
                    <div
                      class="event-type-item"
                      v-for="statusItem in documentationStatuses"
                      :key="statusItem.value"
                    >
                      <div
                        class="
                          event-type-label
                          position-relative
                          d-flex
                          align-items-center
                        "
                      >
                        <i
                          class="fa fa-file"
                          :class="statusItem.class"
                          style="margin-right: 10px"
                        ></i>
                        <label class="event-type-label-item">{{
                          statusItem.label
                        }}</label>
                      </div>
                      <b-form-checkbox class="mb-1" :value="statusItem.value">
                      </b-form-checkbox>
                    </div>
                  </b-form-checkbox-group>
                </div>
              </b-form-group>
            </div>
            <div class="mr-3">
              <b-form-group label="Patients">
                <div class="small-selector">
                  <multiple-select-sidebar-filter
                    v-model="filter.eocs"
                    :options="eocs"
                    :fullWidth="true"
                    :infiniteList="true"
                    placeholder="Search Patients"
                    @search="searchEocs"
                    :async="true"
                  />
                </div>
              </b-form-group>
            </div>
            <div class="mr-3">
              <b-form-group label="Services">
                <div class="small-selector">
                  <multiple-select-sidebar-filter
                    :options="services"
                    v-model="filter.services"
                    :fullWidth="true"
                    placeholder="Search Services"
                    :infiniteList="true"
                  />
                </div>
              </b-form-group>
            </div>
            <div class="mr-3">
              <b-form-group label="Rooms">
                <div class="small-selector">
                  <multiple-select-sidebar-filter
                    :options="rooms"
                    v-model="filter.rooms"
                    :fullWidth="true"
                    placeholder="Search Rooms"
                    :infiniteList="true"
                  />
                </div>
              </b-form-group>
            </div>
            <div class="mr-3" v-if="!selectedLocation">
              <b-form-group label="Locations">
                <div class="small-selector">
                  <multiple-select-sidebar-filter
                    :options="locations"
                    v-model="filter.locations"
                    :fullWidth="true"
                    placeholder="Search locations"
                    :infiniteList="true"
                  />
                </div>
              </b-form-group>
            </div>
            <div class="mr-3" v-if="isByProviderViewActive">
              <b-form-group label="Provider Services">
                <div class="small-selector">
                  <multiple-select-sidebar-filter
                    :options="providersServices"
                    v-model="filter.providersServices"
                    :fullWidth="true"
                    placeholder="Search Services"
                    :infiniteList="true"
                  />
                </div>
              </b-form-group>
            </div>
            <div class="mr-3" v-if="isByProviderViewActive">
              <b-form-group label="Provider Places of Service">
                <div class="small-selector">
                  <multiple-select-sidebar-filter
                    :options="providersPlacesOfService"
                    v-model="filter.providersPlacesOfService"
                    :fullWidth="true"
                    placeholder="Search Places of Service"
                    :infiniteList="true"
                  />
                </div>
              </b-form-group>
            </div>
            <div
              class="mr-3"
              style="margin-bottom: 100px"
              v-if="isByProviderViewActive"
            >
              <b-form-group label="Provider Insurances">
                <div class="small-selector">
                  <multiple-select-sidebar-filter
                    :options="insuranceCompanies"
                    v-model="filter.insuranceCompanies"
                    :fullWidth="true"
                    placeholder="Search Insurance Companies"
                    :infiniteList="true"
                  />
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>

      <div
        class="calendar-content w-100 bg-white"
        :style="`--extra-module-width:calc(${extraModuleWidth}px);`"
      >
        <calendar
          v-if="showing"
          ref="calendar"
          class="h-100"
          :date="calendarDate"
          :tbar="getTbar"
          :modes="modes"
          :events="calendarEvents"
          :resources="calendarResources"
          :sidebar="false"
          :listeners="listeners"
          :eventTooltipFeature="eventTooltipFeature"
          :eventMenuFeature="eventMenuFeature"
          :dragFeature="dragFeature"
          :mode="currentCalendar"
          :modeDefaults="modeDefaults"
        />
      </div>
    </div>

    <user-event-add-edit-modal
      v-if="userEventEditor.show"
      v-model="userEventEditor.show"
      :scheduleEventId="userEventEditor.id"
      :scheduleEventDefaultData="userEventEditor.defaultData"
      :locationId="location"
      @onModify="onModifyAddEditUserEvent"
      @onHidden="
        () => {
          userEventEditor.show = false;
          fetchData();
        }
      "
    />
    <appointment-add-edit-modal
      v-if="appointmentEditor.show"
      v-model="appointmentEditor.show"
      :scheduleEventId="appointmentEditor.id"
      :scheduleEventDefaultData="appointmentEditor.defaultData"
      :locationId="location"
      :providerId="appointmentEditor.providerId"
      @onModify="onModifyAddEditScheduleEvent"
      @onHidden="
        () => {
          appointmentEditor.show = false;
          fetchData();
        }
      "
    />
    <day-in-loc-add-edit-modal
      v-if="locEditor.show"
      v-model="locEditor.show"
      :scheduleEventId="locEditor.id"
      :providerId="locEditor.providerId"
      :scheduleEventDefaultData="locEditor.defaultData"
      :locationId="location"
      @onModify="onModifyAddEditLocEvent"
      @onHidden="
        () => {
          locEditor.show = false;
          fetchData();
        }
      "
    />
    <group-session-add-edit-modal
      v-if="groupEditor.show"
      v-model="groupEditor.show"
      :groupId="groupEditor.id"
      :scheduleEventDefaultData="groupEditor.defaultData"
      :locationId="location"
      :providerId="groupEditor.providerId"
      @onModify="onModifyAddEditGroup"
      @onHidden="
        () => {
          groupEditor.show = false;
          fetchData();
        }
      "
    />
    <group-session-notes-add-edit-modal
      v-if="groupNotesEditor.show"
      v-model="groupNotesEditor.show"
      :scheduleEvent="groupNotesEditor.scheduleEvent"
      @onModify="onModifyGroupNotes"
      @onHidden="onHiddenGroupNotes"
    />
    <group-session-participant-notes-add-edit-modal
      v-if="participantNotesEditor.show"
      v-model="participantNotesEditor.show"
      :scheduleEvent="participantNotesEditor.scheduleEvent"
      :participant="participantNotesEditor.participant"
      @onModify="onModifyGroupNotes"
      @onHidden="onHiddenGroupNotes"
    />
    <group-session-view-modal
      v-if="groupNotesViewer.show"
      v-model="groupNotesViewer.show"
      :groupId="groupNotesViewer.id"
      @onModify="onModifyGroupSessionViewModal"
    />
    <document-add-edit-modal
      v-if="documentEditor.show"
      v-model="documentEditor.show"
      :formId="documentEditor.formId"
      :clientId="documentEditor.clientId"
      :eocId="documentEditor.eocId"
      :submitId="documentEditor.submitId"
      :initialEffectiveDateTime="documentEditor.effectiveDateTime"
      :scheduleEventId="documentEditor.scheduleEventId"
      :scheduleEventParticipantId="documentEditor.scheduleEventParticipantId"
      @onModify="onModifydocumentEditor"
      :attachForm="true"
      :hasAppointmentRelated="hasAppointmentRelated"
    />
    <document-file-add-edit-modal
      v-if="docFileAddEditModal"
      v-model="docFileAddEditModal"
      :eocId="documentEditor.eocId"
      :formId="documentEditor.formId"
      :clientId="documentEditor.clientId"
      :scheduleEventId="documentEditor.scheduleEventId"
      :submitId.sync="documentEditor.submitId"
      @onModify="onModifyDocument"
      :attachForm="true"
    />
    <document-view-modal
      v-if="documentViewModal.show"
      v-model="documentViewModal.show"
      :documentId="documentViewModal.id"
      @onModify="onModifydocumentViewer"
    />
    <report-request-index
      v-if="showReportRequestsModal"
      v-model="showReportRequestsModal"
      :reportFilters="exportFilter"
      reportName="Scheduled Events"
    />
    <b-modal
      centered
      no-close-on-backdrop
      title="Attach new document"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="attachForm"
      v-model="showSubmitForm"
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()"> Close</b-button>
        <b-button variant="primary" v-if="selectedForm != null" @click="ok()">
          Attach
        </b-button>
        <b-button variant="primary" v-else disabled> Attach</b-button>
      </template>
      <b-form-group label="Document type:">
        <v-select v-model="selectedForm" :options="formOptions"></v-select>
      </b-form-group>
      <b-form-group label="" v-slot="{ ariaDescribedby }">
        <b-form-radio-group
          id="radio-group-2"
          v-model="selectedDocType"
          :aria-describedby="ariaDescribedby"
          name="radio-sub-component"
        >
          <b-form-radio class="mr-5" value="standard"
            >Standard Document
          </b-form-radio>
          <b-form-radio value="upload">Document Upload</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </b-modal>
    <b-modal
      centered
      no-close-on-backdrop
      title="Attach existing document"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="attachDocument"
      v-model="showSubmitDocument"
      header-class="bg-purple"
      dialog-class="modal-attach-doc"
      @hidden="clearSearch"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()"> Close</b-button>
        <b-button
          variant="primary"
          v-if="selectedDocuments.length != 0"
          @click="ok()"
        >
          Attach
        </b-button>
        <b-button variant="primary" v-else disabled> Attach</b-button>
      </template>
      <div class="more-info mb-2">
        <span class="b-inline">Select documents to attach:</span>
        <span class="b-inline pull-right"
          >{{ selectedDocuments.length }} documents selected
          <a
            class="btn-link"
            @click="cleanSelectedDocuments"
            style="cursor: pointer"
            >Clear</a
          ></span
        >
      </div>
      <b-form-input
        v-model="docSearch"
        placeholder="Search by Ref# or Document type..."
        @input="fetchDocsByEOC(docSearch, 0)"
      ></b-form-input>
      <document-picker
        ref="documentPicker"
        :docs="documentsByEoc"
        v-model="selectedDocumentsComputed"
        :isLastPage="attachDocPagination.lastPage"
        @loadMore="
          fetchDocsByEOC(docSearch, attachDocPagination.page + 1, true)
        "
      />
    </b-modal>
    <b-modal
      title="Edit recurring event"
      header-bg-variant="primary"
      header-text-variant="white"
      size="md"
      no-close-on-backdrop
      centered
      ref="form-modal"
      @cancel="refreshData"
      @ok="updateAppointments"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <div class="text-right mt-1 mr-2">
          <b-button @click="cancel()" variant="secondary">
            Cancel
          </b-button>
          <b-button class="ml-2" @click="ok()" variant="primary">
            Confirm
          </b-button>
        </div>
      </template>
      <b-form-group v-slot="{ ariaDescribedby }">
        <b-form-radio-group
          :options="options"
          v-model="selectedOption"
          :aria-describedby="ariaDescribedby"
          name="some-radios"
          stacked
        ></b-form-radio-group>
      </b-form-group>
    </b-modal>
    <document-sharing-modal
      v-if="showDocumentSharingModal"
      v-model="showDocumentSharingModal"
      :eocId="eocId"
      :patientId="clientId"
      @viewDocument="viewDocument"
    />
    <event-type-selector-modal
      v-model="showEventTypeSelectorModal"
      @selectEditor="
        (editor, location) => {
          showEventTypeSelectorModal = false;
          selectEditor(editor, location);
        }
      "
      @onHidden="
        () => {
          showEventTypeSelectorModal = false;
          fetchData();
        }
      "
    />
    <billing-document-invoice-add-edit-modal
      :id="newInvoiceModal.id"
      v-if="newInvoiceModal.show"
      v-model="newInvoiceModal.show"
      :showing="newInvoiceModal.show"
      :episodeOfCareId="newInvoiceModal.episodeOfCareId"
      :encounterIds="newInvoiceModal.encounterIds"
      @close="
        () => {
          newInvoiceModal.show = false;
          newInvoiceModal.id = null;
          this.fetchScheduleEvents();
        }
      "
    />

    <billing-document-invoice-view-modal
      v-model="invoiceViewModal.show"
      :id="invoiceViewModal.id"
      :showing="invoiceViewModal.show"
      @close="
        () => {
          invoiceViewModal.show = false;
          invoiceViewModal.id = null;
          this.fetchScheduleEvents();
        }
      "
      @edit="
        data => {
          invoiceViewModal.show = false;
          newInvoiceModal.id = data;
          newInvoiceModal.show = true;
        }
      "
      @payment="
        invoiceData => {
          invoiceViewModal.show = false;
          showInvoicePaymentModal(invoiceData);
        }
      "
    />
    <payment-add-edit-modal
      :transactionType="'Payment'"
      :formTitle="`Add payment for ${paymentAddModal.patient.name}`"
      v-if="paymentAddModal.show"
      v-model="paymentAddModal.show"
      :patientId="paymentAddModal.patient.patientId"
      :invoiceId="paymentAddModal.invoiceId"
      @onHidden="
        () => {
          paymentAddModal.show = false;
          fetchScheduleEvents();
        }
      "
      @success="
        () => {
          paymentAddModal.show = false;
          fetchScheduleEvents();
        }
      "
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment";
import Calendar from "../../third_party/calendar/Calendar.vue";
import { addClass, removeClass, waitForElm } from "../../helpers/layout";
import { lightenDarkenColor } from "../../helpers/general";
import eocServer from "../../server/eoc";
import userServer from "../../server/user";
import scheduleEventServer from "../../server/scheduleEvent";
import appointmentRequestServer from "../../server/appointmentRequest";
import providerAvailabilityServer from "../../server/providerAvailability";
import documentServer from "../../server/document";
import roomServer from "../../server/scheduleEventRoom";
import serviceServer from "../../server/service";
import formSumitterServer from "../../server/formSubmitter";
import MultipleSelectSidebarFilter from "../controls/MultipleSelectSidebarFilter.vue";
import UserEventAddEditModal from "./UserEventAddEditModal.vue";
import AppointmentAddEditModal from "./AppointmentAddEditModal.vue";
import DayInLocAddEditModal from "./DayInLocAddEditModal.vue";
import GroupSessionAddEditModal from "../group_session/GroupSessionAddEditModal.vue";
import GroupSessionNotesAddEditModal from "../group_session/GroupSessionNotesAddEditModal.vue";
import GroupSessionParticipantNotesAddEditModal from "../group_session/GroupSessionParticipantNotesAddEditModal.vue";
import GroupSessionViewModal from "../group_session/GroupSessionViewModal.vue";
import BillingDocumentInvoiceAddEditModal from "../billing/billing_document/BillingDocumentInvoiceAddEditModal.vue";
import BillingDocumentInvoiceViewModal from "../billing/billing_document/BillingDocumentInvoiceViewModal.vue";
import PaymentAddEditModal from "../billing/billing_transactions/PaymentAddEditModal.vue";
import DocumentAddEditModal from "../episode_of_care/document/DocumentAddEditModal.vue";
import DocumentFileAddEditModal from "../episode_of_care/document/DocumentFileAddEditModal.vue";
import DocumentViewModal from "../episode_of_care/document/DocumentViewModal.vue";
import DocumentPicker from "../controls/DocumentPicker";
import avatarServer from "../../server/avatar";
import ReportRequestIndex from "../report_request/ReportRequestIndex.vue";
import { getSidebarCollapsed } from "../../../../Breeze.FormBuilder.Frontend/helpers/session";
import { getFormBuilderComponents } from "../../../../Breeze.FormBuilder.Frontend/helpers/formBuilder";
import DocumentSharingModal from "../episode_of_care/document_sharing/DocumentSharingModal.vue";
import insuranceCompanyServer from "../../server/insuranceCompany";
import EventTypeSelectorModal from "./EventTypeSelectorModal.vue";
import appointmentSignalRConnection from "../../signalr/appointments";

export default {
  name: "SchedulerIndex",
  components: {
    Calendar,
    UserEventAddEditModal,
    AppointmentAddEditModal,
    DayInLocAddEditModal,
    GroupSessionAddEditModal,
    GroupSessionNotesAddEditModal,
    GroupSessionParticipantNotesAddEditModal,
    GroupSessionViewModal,
    BillingDocumentInvoiceAddEditModal,
    BillingDocumentInvoiceViewModal,
    PaymentAddEditModal,
    DocumentAddEditModal,
    DocumentFileAddEditModal,
    MultipleSelectSidebarFilter,
    DocumentViewModal,
    ReportRequestIndex,
    DocumentPicker,
    DocumentSharingModal,
    EventTypeSelectorModal
  },
  props: ["showing"],
  data() {
    const self = this;
    return {
      providers: [],
      providersPage: 1,
      providersPageSize: 10,
      oldStatusId: "",
      showDocumentSharingModal: false,
      clientId: null,
      extraModuleWidth: getSidebarCollapsed() ? 180 : 0,
      docFileAddEditModal: false,
      selectedDocType: "standard",
      docSearch: null,
      showSubmitForm: false,
      showSubmitDocument: false,
      selectedForm: null,
      showAttach: false,
      selectedDocuments: [],
      selectedScheduleEventId: null,
      clientOptions: [],
      clientSearchChanged: false,
      eocId: null,
      documentsByEoc: [],
      scheduleEvents: [],
      scheduleEvent: {},
      appointmentRequests: [],
      providerAvailabilities: [],
      providerNonAvailabilities: [],
      eocs: [],
      users: [],
      services: [],
      facilitators: [],
      rooms: [],
      insuranceCompanies: [],
      providersServices: [],
      isMonthViewActive: false,
      isByProviderViewActive: false,
      hasAppointmentRelated: false,
      appointmentEditor: {
        show: false,
        id: null,
        providerId: null,
        defaultData: null
      },
      groupEditor: {
        show: false,
        id: null,
        providerId: null,
        defaultData: null
      },
      userEventEditor: {
        show: false,
        id: null,
        defaultData: null
      },
      locEditor: {
        show: false,
        id: null,
        providerId: null,
        defaultData: null
      },
      documentEditor: {
        show: false,
        formId: null,
        clientId: null,
        eocId: null,
        submitId: null,
        effectiveDateTime: null,
        scheduleEventId: null,
        scheduleEventParticipantId: null
      },
      groupNotesEditor: {
        show: false,
        scheduleEvent: null
      },
      groupNotesViewer: {
        show: false,
        id: null
      },
      participantNotesEditor: {
        show: false,
        scheduleEvent: null,
        participant: null
      },
      documentViewModal: {
        show: false,
        id: null
      },
      newInvoiceModal: {
        show: false,
        id: null,
        episodeOfCareId: null,
        encounterIds: []
      },
      invoiceViewModal: {
        show: false,
        id: null
      },
      paymentAddModal: {
        show: false,
        patient: null,
        invoiceId: null
      },
      location: null,
      showReportRequestsModal: false,
      showEventTypeSelectorModal: false,
      eventTypeSelectorDefaultData: null,
      selectedEventData: null,
      searchEocPhraseLength: 0,
      options: [
        { value: "ModifySingleEvent", text: "This event" },
        {
          value: "ModifyEventAndRecurrence",
          text: "This and following events"
        },
        { value: "ModifyRecurrence", text: "All events" }
      ],
      selectedOption: "ModifySingleEvent",
      formData: null,
      tbar: {
        items: {
          todayButton: false,
          prevButton: false,
          nextButton: false,
          addScheduleEvent: {
            type: "button",
            text: "New Event",
            color: "b-blue b-raised",
            icon: "b-fa b-fa-calendar-plus",
            cls: "",
            tooltip: "",
            onClick: () => this.addScheduleEvent()
          }
        }
      },
      dragFeature: {
        newName: "New event",
        recurrenceTip: "",
        validateCreateFn: ({ eventRecord }) => {
          if (
            this.formatDateOnlyMysql(eventRecord.data.startDate) !=
            this.formatDateOnlyMysql(eventRecord.data.endDate)
          ) {
            return false;
          }
          if (
            this.datesNonWorking(null, eventRecord.data.startDate) ||
            this.datesNonWorking(null, eventRecord.data.endDate)
          ) {
            this.showAlertError({
              message: "Events cannot be created outside hours of operation"
            });
            return false;
          }
        },
        validateMoveFn: ({ eventRecord }) => {
          const endDate = moment(eventRecord.data.endDate).add(-1, "seconds");
          if (
            this.datesNonWorking(null, eventRecord.data.startDate) ||
            this.datesNonWorking(null, endDate.toDate())
          ) {
            this.showAlertError({
              message: "Events cannot be moved outside hours of operation"
            });
            return false;
          }
        },
        validateResizeFn: ({ eventRecord }) => {
          if (
            this.formatDateOnlyMysql(eventRecord.data.startDate) !=
            this.formatDateOnlyMysql(eventRecord.data.endDate)
          ) {
            return false;
          }
        }
      },
      filter: {
        startDate: this.formatDateOnlyMysql(),
        endDate: this.formatDateOnlyMysql(),
        eocs: [],
        users: [],
        status: [],
        services: [],
        facilitators: [],
        placeOfService: [],
        documentationStatus: [],
        rooms: [],
        insuranceCompanies: [],
        providersServices: [],
        providersPlacesOfService: [],
        locations: []
      },
      attachDocPagination: {
        pageSize: 10,
        page: 0,
        count: 0,
        lastPage: false
      },
      date: this.formatDateOnlyMysql(),
      listeners: {
        beforeEventEdit: this.beforeEventEdit,
        beforeEventDelete: this.beforeEventDelete,
        dayNumberClick: this.setDate,
        weekNumberClick: this.setDate,
        dateRangeChange: this.dateRangeChange,
        activeItemChange: this.activeItemChange,
        eventClick: this.eventClick,
        dragMoveEnd: this.dragMoveResizeEnd,
        dragResizeEnd: this.dragMoveResizeEnd,
        viewpaint: this.viewpaint,
        daterangerequested: this.dateRangeRequested,
        beforeDragCreateEnd: this.beforeDragCreateEnd
      },
      eventMenuFeature: {
        disabled: true
      },
      eventTooltipFeature: {
        showOn: "click",
        onShow: async e => {
          const scheduleEventId =
            e.source._eventRecord?.originalData.eventData?.id;
          const el = document.getElementById(e.source.id);
          await waitForElm(".schedule-event-tooltip-data");
          const button = el.querySelector("button.btn-checkedin");
          const selects = el.querySelectorAll("select.status-select");
          if (selects && selects.length) {
            selects.forEach(select => {
              const dataId = select.getAttribute("data-id");
              const status = this.scheduleEvents.flatMap(x =>
                x.episodesOfCare.filter(y => y.id == dataId)
              )[0].scheduleEventStatus;

              const color = status.color;
              const bgColor = lightenDarkenColor(color, 85);
              select.value = status.id;
              select.style.color = color;
              select.style.backgroundColor = bgColor;

              if (button)
                if (status.name == "Show") {
                  button.style.display = "block";
                } else {
                  button.style.display = "none";
                }

              select.onfocus = () => {
                this.oldStatusId = select.value;
              };
              select.onchange = async e => {
                const participantId = select.dataset.id;
                const statusId = e.target.value;
                const status = this.statuses.find(u => u.value == statusId)
                  .data;

                if (button)
                  if (status.name == "Show") {
                    button.style.display = "block";
                  } else {
                    button.style.display = "none";
                  }

                select.style.color = status.color;
                select.style.backgroundColor = status.backgroundColor;
                await scheduleEventServer.setStatus(participantId, {
                  statusId
                });
                const oldStatusId = this.oldStatusId;

                const scheduleEvent = await scheduleEventServer.get(
                  scheduleEventId
                );

                if (
                  scheduleEvent.type.code == "appointment" ||
                  scheduleEvent.type.code == "loc"
                ) {
                  const element = document.getElementById("billing");
                  const billingInfo = await scheduleEventServer.getCostVariations(
                    participantId,
                    { statusId, oldStatusId }
                  );
                  if (
                    billingInfo &&
                    this.hasCurrentUserPermissionAccess(
                      "others",
                      "patientBillingInfo"
                    )
                  ) {
                    if (element) element.style.display = "block";

                    this.setElementInnerHTMLById(
                        "totalAmount",
                        `Fee: ${this.toCurrencyValue(billingInfo.totalAmount)}`
                    );
                    this.setElementInnerHTMLById(
                        "insuranceAmount",
                        `Insurance: ${
                            billingInfo.insuranceAmount < 0
                                ? 0
                                : this.toCurrencyValue(billingInfo.insuranceAmount)
                        }`
                    );
                    this.setElementInnerHTMLById(
                        "clientAmount",
                        `Client: ${this.toCurrencyValue(billingInfo.clientAmount)}`
                    );
                  } else {
                    if (element) element.style.display = "none";
                  }
                }

                this.oldStatusId = select.value;

                const tooltipItemServices = document.getElementById(
                  "tooltip-item-services"
                );
                if (tooltipItemServices) {
                  tooltipItemServices.innerHTML = this.getToolTipServices(
                    scheduleEvent
                  );
                }

                const tooltipItemDocuments = document.getElementById(
                  "tooltip-item-documents"
                );
                if (tooltipItemDocuments) {
                  tooltipItemDocuments.innerHTML = this.getToolTipDocuments(
                    scheduleEvent
                  );
                  this.linkAttachForm();
                  this.linkForms(e);
                }

                scheduleEventServer.sendToPortal(
                  this.tenantName,
                  scheduleEventId,
                  this.signalRAppUrl
                );
                this.fetchScheduleEvents();
                this.fetchAppointmentRequests();
              };
            });
          }

          if (button) {
            button.onclick = async () => {
              const participantId = button.dataset.id;
              const checkedIn = button.dataset.checkedin === "true";
              button.innerHTML = checkedIn
                ? button.innerHTML.replace(/Out/g, "In")
                : button.innerHTML.replace(/In/g, "Out");
              button.classList.toggle("btn-success");
              button.classList.toggle("btn-outline-success");
              await scheduleEventServer.setCheckedIn(participantId, {
                checkedIn: !checkedIn
              });
              scheduleEventServer.sendToPortal(
                this.tenantName,
                scheduleEventId,
                this.signalRAppUrl
              );
              button.dataset.checkedin = `${!checkedIn}`;
              this.fetchScheduleEvents();
              this.fetchAppointmentRequests();
            };
          }

          this.linkAttachForm();

          const resendLink = el.querySelector("#resend-invitation");
          if (resendLink) {
            resendLink.onclick = async () => {
              this.confirmResend(
                resendLink.dataset.patientFirstname,
                resendLink.dataset.patientLastname,
                resendLink.dataset.eventId,
                resendLink.dataset.eocId
              );
            };
          }

          const createInvoiceLink = el.querySelector("#create-client-invoice");
          if (createInvoiceLink) {
            createInvoiceLink.onclick = () => {
              this.newInvoiceModal = {
                show: true,
                id: null,
                episodeOfCareId: createInvoiceLink.dataset.eocId,
                encounterIds: [createInvoiceLink.dataset.encounterId]
              };
            };
          }

          const showInvoiceLinks = el.querySelectorAll(
            "[id^='show-client-invoice_']"
          );
          showInvoiceLinks.forEach(showInvoiceLink => {
            showInvoiceLink.onclick = () => {
              this.invoiceViewModal = {
                show: true,
                id: showInvoiceLink.dataset.invoiceId
              };
            };
          });
          const buttonLinkCopy = el.querySelector("#copyButtonLink");
          if (buttonLinkCopy) {
            buttonLinkCopy.onclick = async () => {
              await navigator.clipboard.writeText(
                buttonLinkCopy.dataset.eventLink
              );
              this.showAlertSuccess({ message: "Link Copied" });
            };
          }

          this.linkForms(e);

          const groupParticipants = el.querySelectorAll(
            "a[data-group-participant]"
          );
          groupParticipants.forEach(node => {
            const metadata = JSON.parse(node.dataset.groupParticipant);
            const participant = this.scheduleEvent.episodesOfCare.find(
              u => u.id == metadata.participantId
            );
            node.onclick = e => {
              e.preventDefault();
              this.participantNotesEditor.scheduleEvent = this.scheduleEvent;
              this.participantNotesEditor.participant = participant;
              this.participantNotesEditor.show = true;
            };
          });

          const groupParticipantsResendInvitation = el.querySelectorAll(
            "a[data-group-participant-resend-invitation]"
          );
          groupParticipantsResendInvitation.forEach(node => {
            const metadata = JSON.parse(
              node.dataset.groupParticipantResendInvitation
            );
            const scheduleEvent = this.scheduleEvents.find(
              u => u.id == metadata.eventId
            );
            const participant = scheduleEvent.episodesOfCare.find(
              u => u.id == metadata.participantId
            );

            node.onclick = e => {
              e.preventDefault();
              this.confirmResend(
                participant.episodeOfCare.patient.firstName,
                participant.episodeOfCare.patient.lastName,
                scheduleEvent.id,
                participant.episodeOfCare.id
              );
            };
          });
        },
        renderer: async data => {
          if (data.eventRecord.data.eventData.type.code == "nonAvailability") {
            return;
          }
          return await this.getTooltipHtml(data.eventRecord.data.eventData.id);
        },
        tools: {
          edit: {
            cls: this.isStandalone()
              ? "custom-icon custom-icon-edit m-0 p-0"
              : "custom-icon custom-icon-edit-prod m-0 p-0"
          },
          delete: {
            cls: this.isStandalone()
              ? "custom-icon custom-icon-delete m-0 p-0"
              : "custom-icon custom-icon-delete-prod m-0 p-0"
          },
          close: {
            cls: this.isStandalone()
              ? "custom-icon custom-icon-close m-0 p-0"
              : "custom-icon custom-icon-close-prod m-0 p-0"
          },
          docReqAndSharing: {
            cls: this.isStandalone()
              ? "custom-icon custom-icon-doc-request m-0 p-0"
              : "custom-icon custom-icon-doc-request-prod m-0 p-0",
            weight: 200,
            tooltip: "Document Request & Sharing",
            handler() {
              self.appointmentEditor.id = null;
              self.appointmentEditor.defaultData = {
                ...this.eventRecord.data.eventData
              };
              self.clientId =
                self.appointmentEditor.defaultData.episodesOfCare[0].episodeOfCare.patient.id;
              self.eocId =
                self.appointmentEditor.defaultData.episodesOfCare[0].episodeOfCare.id;
              delete self.appointmentEditor.defaultData.id;
              self.showDocumentSharingModal = true;
            }
          },
          followUp: {
            cls: this.isStandalone()
              ? "custom-icon custom-icon-follow-up m-0 p-0"
              : "custom-icon custom-icon-follow-up-prod m-0 p-0",
            weight: 200,
            tooltip: "Follow Up",
            handler() {
              self.appointmentEditor.id = null;
              self.appointmentEditor.defaultData = self.scheduleEvent;
              delete self.appointmentEditor.defaultData.id;
              self.appointmentEditor.show = true;
            }
          },
          notes: {
            cls: this.isStandalone()
              ? "custom-icon custom-icon-notes m-0 p-0"
              : "custom-icon custom-icon-notes-prod m-0 p-0",
            weight: 200,
            tooltip: "Open Notes",
            handler() {
              self.groupNotesEditor.show = true;
              self.groupNotesEditor.scheduleEvent = self.scheduleEvent;
            }
          },
          view: {
            cls: this.isStandalone()
              ? "custom-icon custom-icon-view m-0 p-0"
              : "custom-icon custom-icon-view-prod m-0 p-0",
            weight: 200,
            tooltip: "View",
            handler() {
              self.groupNotesViewer.show = true;
              self.groupNotesViewer.id = this.eventRecord.data.eventData.id;
            }
          }
        },
        header: {
          titleAlign: "start"
        },
        hideDelay: false
      },
      documentationStatuses: [
        {
          value: "Completed",
          label: "Documentation completed",
          class: "text-success"
        },
        {
          value: "Incomplete",
          label: "Documentation incomplete",
          class: "text-danger"
        }
      ],
      isSignalConnected: false
    };
  },
  async mounted() {
    const currentAdjustedDateTime = this.getCurrentAdjustedDateTime();
    this.date = this.formatDateOnlyMysql(currentAdjustedDateTime);
    window.dispatchEvent(new Event("resize"));
    await this.fetchProviders(true);
    this.location = this.selectedLocation ? this.selectedLocation.id : null;
  },
  updated() {
    if (this.showing && !this.isSignalConnected) {
      appointmentSignalRConnection.initialize(
        "appointments",
        this.signalRAppUrl
      );
      appointmentSignalRConnection.start();

      this.isSignalConnected = true;

      appointmentSignalRConnection.on("UpdateMainAppAppointment", result => {
        if (result && result.tenantName === this.tenantName) {
          const isRenderedEvent = this.scheduleEvents.find(
            event => event.id === result.scheduleEventId
          );
          if (isRenderedEvent) {
            this.refetchEvent(result.scheduleEventId);
          }
        }
      });
    }
  },
  methods: {
    ...mapActions("client", [
      "fetchScheduleEventStatuses",
      "fetchLevelsOfCare",
      "fetchLocations",
      "fetchPlacesOfService"
    ]),
    ...mapActions("formBuilder", ["fetchFormBuilderForms"]),
    ...mapActions("layout", [
      "showAlertSuccess",
      "showAlertError",
      "toggleAssignToMeSchedulerIndex",
      "currentCalendarViewIndex",
      "fetchCurrentUser"
    ]),
    ...mapActions("layout", {
      showLoading: "show",
      hideLoading: "hide",
      increaseRequestsPending: "increaseRequestsPending",
      decreaseRequestsPending: "decreaseRequestsPending"
    }),
    setElementInnerHTMLById(id, value) {
      const element = document.getElementById(id);
      if (element) {
        element.innerHTML = value;
      }
    },
    keepTooltip(tooltipEvent, callbackClickOutside) {
      this.forceToShowTooltipInstance(tooltipEvent);

      const listener = async event => {
        const clickedOutside = !tooltipEvent.source.currentElement.contains(
          event.target
        );

        if (clickedOutside) {
          this.removeTooltipContent();

          if (callbackClickOutside) callbackClickOutside();
        }

        document.removeEventListener("click", listener);
      };

      document.addEventListener("click", listener);
    },
    forceToShowTooltipInstance(tooltipEvent) {
      tooltipEvent.type = "show";
      tooltipEvent.source._hidden = false;
    },
    getTooltipContainerElement() {
      return document.querySelectorAll(`.b-float-root`)[0];
    },
    removeTooltipContent() {
      const tooltipContainer = this.getTooltipContainerElement();
      this.removeAllChild(tooltipContainer);
    },
    removeAllChild(element) {
      while (element.firstChild) {
        element.removeChild(element.firstChild);
      }
    },
    clearSearch() {
      this.docSearch = null;
      this.documentsByEoc = [];
    },
    loadMoreProviders() {
      this.startHideLoadingChecker();
      this.providersPage += 1;

      this.insertPlaceOfService();
    },
    loadAllProviders() {
      this.startHideLoadingChecker();
      this.providersPage = 1;
      this.providersPageSize = 1000000;

      this.insertPlaceOfService();
    },
    startHideLoadingChecker() {
      this.increaseRequestsPending();
      this.showLoading();
      setTimeout(() => {
        this.decreaseRequestsPending();
        this.hideLoading();
      }, 500);
    },
    isFormAvailableInMyLocation(id) {
      if (this.selectedLocation && this.selectedLocation.formIds.includes(id)) {
        return true;
      }
      return false;
    },
    getBatchesAndAlertTooltip(participant) {
      return `
        <div class="px-2 m-1">
              <div class="tooltip-item px-2 m-1" >
                <div class="d-flex flex-row justify-content-start flex-wrap">
                  ${participant.episodeOfCare.notes
                    .map(notes => {
                      if (notes.status !== "Disabled") {
                        return `<i
                          class="alert-note-icon fas fa-exclamation-circle text-danger mr-1"
                          data-toggle="tooltip" data-placement="top" title="${notes.content}"
                        ></i>
                        <div class="tooltip-value text-danger mr-2">
                          ${notes.content}
                        </div>
                        `;
                      } else {
                        return ``;
                      }
                    })
                    .reduce((x, y) => x + y, "")}
                </div>
              </div>
                <div class="d-flex flex-row justify-content-start flex-wrap m-1">
                  ${participant.episodeOfCare.badges
                    .map(
                      badge =>
                        `
                        <div class="tooltip-item mr-2"  data-toggle="tooltip" data-placement="top" title="${badge.name}">
                          <div
                            class="badge badge-pill"
                            style="min-width: 70px; background-color: ${badge.category.color};"
                            id="badge-tooltip-view-${badge.id}"
                          >
                            <span class="h6 tooltip-value text-white">${badge.acronym}</span>
                          </div>
                        </div>
                        `
                    )
                    .reduce((x, y) => x + y, "")}
                </div>
              </div>
      `;
    },
    setDate(event) {
      this.date = this.formatDateOnlyMysql(event.date);
    },
    cleanSelectedDocuments() {
      this.selectedDocuments = [];
      this.$refs["documentPicker"].clear();
    },
    dateRangeChange(event) {
      this.filter.startDate = this.formatDateOnlyMysql(event.new.startDate);
      this.filter.endDate = this.formatDateOnlyMysql(
        moment(event.new.endDate)
          .add(-1, "day")
          .toDate()
      );
      if (this.showing) {
        this.fetchProviderAvailabilities();
        this.fetchData();
      }
    },
    activeItemChange(event) {
      const prevFilter = { ...this.filter };
      this.filter.startDate = this.formatDateOnlyMysql(
        event.activeItem.startDate
      );
      this.filter.endDate = this.formatDateOnlyMysql(
        moment(event.activeItem.endDate)
          .add(-1, "day")
          .toDate()
      );
      if (
        this.filter.startDate != prevFilter.startDate ||
        this.filter.endDate != prevFilter.endDate
      )
        this.fetchData();
      if (
        event.activeItem.modeName == "byProvider" &&
        event.prevActiveItem.modeName == "day"
      ) {
        this.insertPlaceOfService();
        this.insertLoadMoreLogic();
      }
    },
    async viewDocument(documentId) {
      const document = await formSumitterServer.getDetailedImproved(documentId);

      if (document.mode == "File") {
        const url = formSumitterServer.viewUrl(documentId);
        window.open(url, "_blank");
      } else {
        this.documentViewModal = { show: true, id: documentId };
      }
    },
    async eventClick(event) {
      if (event.eventRecord.data.eventData.type.code == "nonAvailability") {
        return;
      }
      let scheduleEvent = await scheduleEventServer.get(
        event.eventRecord.data.eventData.id,
        {
          "Hide-Loading": true
        }
      );
      const floatRoot = document.querySelectorAll(`.b-float-root`);
      if (floatRoot.length > 0) {
        const eventData = scheduleEvent;
        const encounterSubmited = eventData.billingInfo?.encounterSubmited;
        if (eventData.episodesOfCare.length > 0) {
          const availableForms = eventData.episodesOfCare[0].linkedDocuments.filter(
            x =>
              (this.selectedLocation &&
                this.selectedLocation.formIds.indexOf(x.formId) !== -1) ||
              x.form.category == "masterTreatmentPlan"
          );
          eventData.episodesOfCare[0].linkedDocuments = availableForms;
        }
        if (eventData.type.code == "appointment") {
          this.hasAppointmentRelated = true;
          removeClass(floatRoot[0], "hide-sibling-follow-up");
          removeClass(floatRoot[0], "hide-sibling-doc-req-and-sharing");
          addClass(floatRoot[0], "hide-sibling-notes");
          addClass(floatRoot[0], "hide-sibling-view");
          if (encounterSubmited && !this.canEditChargedEvents) {
            addClass(floatRoot[0], "hide-sibling-edit");
            addClass(floatRoot[0], "hide-sibling-delete");
          } else {
            removeClass(floatRoot[0], "hide-sibling-edit");
            removeClass(floatRoot[0], "hide-sibling-delete");
          }
        } else if (eventData.type.code == "groupSession") {
          addClass(floatRoot[0], "hide-sibling-follow-up");
          addClass(floatRoot[0], "hide-sibling-doc-req-and-sharing");
          if (encounterSubmited && !this.canEditChargedEvents) {
            addClass(floatRoot[0], "hide-sibling-edit");
            addClass(floatRoot[0], "hide-sibling-delete");
          } else {
            removeClass(floatRoot[0], "hide-sibling-edit");
            removeClass(floatRoot[0], "hide-sibling-delete");
          }
          if (eventData.episodesOfCare.length == 0) {
            addClass(floatRoot[0], "hide-sibling-notes");
            addClass(floatRoot[0], "hide-sibling-view");
          } else {
            removeClass(floatRoot[0], "hide-sibling-notes");
            if (
              eventData.episodesOfCare
                .map(p => p.linkedDocuments)
                .reduce((acc, val) => acc.concat(val), [])
                .filter(d => d.document).length > 0
            ) {
              removeClass(floatRoot[0], "hide-sibling-view");
            } else {
              addClass(floatRoot[0], "hide-sibling-view");
            }
          }
        } else if (eventData.type.code == "other") {
          addClass(floatRoot[0], "hide-sibling-follow-up");
          addClass(floatRoot[0], "hide-sibling-doc-req-and-sharing");
          addClass(floatRoot[0], "hide-sibling-notes");
          addClass(floatRoot[0], "hide-sibling-view");
        } else if (eventData.type.code == "loc") {
          addClass(floatRoot[0], "hide-sibling-follow-up");
          addClass(floatRoot[0], "hide-sibling-doc-req-and-sharing");
          addClass(floatRoot[0], "hide-sibling-notes");
          addClass(floatRoot[0], "hide-sibling-view");
          if (encounterSubmited && !this.canEditChargedEvents) {
            addClass(floatRoot[0], "hide-sibling-edit");
            addClass(floatRoot[0], "hide-sibling-delete");
          } else {
            removeClass(floatRoot[0], "hide-sibling-edit");
            removeClass(floatRoot[0], "hide-sibling-delete");
          }
        } else if (eventData.type.code == "appointmentRequest") {
          removeClass(floatRoot[0], "hide-sibling-follow-up");
          removeClass(floatRoot[0], "hide-sibling-doc-req-and-sharing");
          removeClass(floatRoot[0], "hide-sibling-notes");
          removeClass(floatRoot[0], "hide-sibling-view");
        }
      }
    },
    async dragMoveResizeEnd({ eventRecord, view, drag }) {
      const modeName = view.modeName;
      const targetZone = Object.getPrototypeOf(drag._target).constructor.name;
      const newStartDate = eventRecord.data.startDate;
      const newEndDate = eventRecord.data.endDate;
      const id = eventRecord.data.eventData.id;
      const allDay = this.scheduleEvents.find(x => x.id == id).allDay;

      this.formData = {
        startDateTime:
          allDay || targetZone === "AllDayZone"
            ? this.formatDateOnlyMysql(newStartDate)
            : this.formatDateTimeSql(newStartDate),
        endDateTime:
          allDay || targetZone === "AllDayZone"
            ? null
            : this.formatDateTimeSql(newEndDate),
        [view.resourceId ? "users" : null]:
          view.resourceId === -1 ? [] : [view.resourceId],
        [modeName !== undefined && !allDay && targetZone !== "AllDayZone"
          ? "users"
          : null]:
          eventRecord.resourceId === -1 ? [] : [eventRecord.resourceId],
        id: id
      };
      let isConfirmedIfAppoitmentsColide = await this.confirmIfAppoitmentsColide(
        this.formData,
        eventRecord,
        newStartDate,
        newEndDate
      );

      if (this.formData[null] != [] && modeName !== undefined) {
        if (
          !this.formData["users"] &&
          eventRecord.data.eventData.type.code !== "loc" &&
          eventRecord.data.eventData.type.code !== "other"
        ) {
          this.formData["users"] = this.formData[null];
        } else if (eventRecord.data.eventData.type.code === "other") {
          delete this.formData["users"];
        }
      }

      if (isConfirmedIfAppoitmentsColide) {
        const dialog = await this.$dialog
          .confirm(
            {
              title: "Do you want to notify participants?"
            },
            {
              view: "multiple-actions",
              options: [
                { value: true, label: "Yes" },
                { value: false, label: "No" }
              ]
            }
          )
          .catch(() => this.fetchData());
        this.formData.resend = dialog.data.value;
      }
      if (
        isConfirmedIfAppoitmentsColide &&
        eventRecord.data.eventData.recurrenceId
      ) {
        this.$refs["form-modal"].show();
      } else {
        try {
          this.formData.modification = "ModifySingleEvent";
          await scheduleEventServer.updateDates(
            this.formData.id,
            this.formData
          );
          this.showAlertSuccess();
        } catch (error) {
          await this.showAlertError({
            message: error.response.data.message
          });
        } finally {
          this.fetchData();
        }
      }
    },
    async fetchProviders(populateProvider = false) {
      await this.fetchUsers();
      await this.fetchCurrentUser();
      if (
        populateProvider &&
        this.providerUsers.some(user => user.value === this.currentUser.id)
      ) {
        this.filter.users = this.providerUsers.find(
          user => user.value === this.currentUser.id
        );
      }
    },
    async fetchInitialData() {
      this.fetchEocs(null);
      this.fetchScheduleEventStatuses();
      this.fetchServices();
      this.fetchLevelsOfCare();
      this.fetchRooms();
      this.fetchInsuracesCompanies();
      this.fetchProvidersServices();
      await this.fetchPlacesOfService();
      await this.fetchLocations();
      this.fetchFormBuilderForms({ category: "main" });
      this.fetchFormBuilderForms({ category: "masterTreatmentPlan" });
    },
    beforeEventEdit(event) {
      const eventType = event.eventRecord.data.eventData?.type.code;
      if (!eventType) {
        event.eventElement.hidden = true;
        var defaultData = {
          startDateTime: this.formatDateTimeMysql(
            event.eventRecord.data.startDate
          ),
          endDateTime: this.formatDateTimeMysql(event.eventRecord.data.endDate),
          providerId: this.isByProviderViewActive
            ? event.eventRecord.data.resourceId
            : this.filter.users?.value
        };
        this.addScheduleEvent(defaultData);
      }

      if (!this.location) {
        this.location = this.scheduleEvent.location?.id;
      }

      const encounterSubmited = this.scheduleEvent.billingInfo?.encounterSubmited;
      const canEditEvent = !encounterSubmited || this.canEditChargedEvents; 
      if (eventType == "appointment" && canEditEvent) {
        this.appointmentEditor.id = event.eventRecord.data.eventData?.id;
        this.appointmentEditor.show = true;
        this.appointmentEditor.defaultData = null;
        this.appointmentEditor.providerId = null;
      }
      if (eventType == "groupSession" && canEditEvent) {
        this.groupEditor.id = event.eventRecord.data.eventData.id;
        this.groupEditor.show = true;
        this.groupEditor.providerId = null;
      }
      if (eventType == "other") {
        this.userEventEditor.id = event.eventRecord.data.eventData.id;
        this.userEventEditor.show = true;
      }
      if (eventType == "loc") {
        this.locEditor.id = event.eventRecord.data.eventData.id;
        this.locEditor.providerId = this.filter.users?.value;
        this.locEditor.show = true;
      }
      return false;
    },
    beforeEventDelete(event) {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to delete this record?"
          },
          {
            view: "confirm-delete",
            checkbox:
              event.eventRecords[0].data.eventData.type.code !== "other",
            checkboxBody:
              event.eventRecords[0].data.eventData.type.code !== "other"
                ? "Do you want to delete the documents associated with this event?"
                : ""
          }
        )
        .then(async dialog => {
          let result = await scheduleEventServer.delete(
            event.eventRecords[0].data.eventData.id,
            dialog.data
          );
          if (result.errorCode) {
            this.$dialog.alert("Error: " + result.message);
          } else {
            this.fetchScheduleEvents();
            this.fetchAppointmentRequests();
            this.showAlertSuccess();
          }
        })
        .catch(function() {});
      return false;
    },
    fetchData() {
      this.fetchAppointmentRequests();
      return this.fetchScheduleEvents();
    },
    changeAssignedToMEToggle() {
      this.toggleAssignToMeSchedulerIndex();
      this.fetchScheduleEvents();
    },
    async fetchAppointmentRequests() {
      this.appointmentRequests = await appointmentRequestServer.query({
        startDateTime: this.formatStartDateSql(this.filter.startDate),
        endDateTime: this.formatEndDateSql(this.filter.endDate),
        service: this.filter.services.map(service => service.value),
        provider:
          this.filter.users && this.filter.users.value
            ? [this.filter.users.value]
            : [],
        episodesOfCare: this.filter.eocs.map(eoc => eoc.value),
        pageSize: 1000000
      });
    },
    async fetchScheduleEvents() {
      this.scheduleEvents = await scheduleEventServer.query({
        startDateFrom: this.formatStartDateSql(this.filter.startDate),
        startDateTo: this.formatEndDateSql(this.filter.endDate),
        episodeOfCareIds: this.filter.eocs.map(eoc => eoc.value),
        statusId: this.filter.status,
        userIds:
          this.filter.users && this.filter.users.value
            ? [this.filter.users.value]
            : [],
        facilitatorIds: this.filter.facilitators.map(
          facilitator => facilitator.value
        ),
        placeOfServiceIds: this.filter.placeOfService.map(pos => pos.value),
        locationIds: this.filter.locations.map(location => location.value),
        serviceId: this.filter.services.map(service => service.value),
        roomIds: this.filter.rooms.map(room => room.value),
        documentationStatus: this.filter.documentationStatus,
        assignedToMe: this.assignedToMe
      });
      if (this.isByProviderViewActive) this.searchProviders();
    },
    async fetchProviderAvailabilities() {
      this.providerAvailabilities = await providerAvailabilityServer.queryMinimal(
        {
          startDate: this.filter.startDate + "T00:00:00",
          endDate: this.filter.endDate + "T23:59:59",
          providerIds:
            this.filter.users && this.filter.users.value
              ? [this.filter.users.value]
              : [],
          notIncludeServices: true,
          locationId: this.selectedLocation ? this.selectedLocation.id : null
        }
      );
      if (this.providerAvailabilities.length === 0)
        this.providerNonAvailabilities = [];
    },
    async searchProviders() {
      if (this.providerFilterEnabled) {
        let providers = await userServer.getFilteredProviders({
          startDateTime: this.formatDateTimeSql(this.date + "T00:00:00"),
          providersServicesIds: this.filter.providersServices.map(
            ps => ps.value
          ),
          placesOfServiceIds: this.filter.providersPlacesOfService.map(
            pps => pps.value
          ),
          insuranceCompaniesIds: this.filter.insuranceCompanies.map(
            ic => ic.value
          )
        });
        this.providers = providers.map(user => ({
          value: user.id,
          label: this.formatUser(user),
          data: user
        }));
      }
      if (this.scheduleFilterEnabled) {
        const userIds = this.scheduleEvents
          .flatMap(x => x.users)
          .map(user => user.id);
        const filteredUsers = this.users.filter(
          user => user.data.providerInfo && userIds.includes(user.value)
        );
        if (this.providerFilterEnabled) {
          const filteredUserIds = filteredUsers.map(x => x.value);
          this.providers = this.providers.filter(user =>
            filteredUserIds.includes(user.value)
          );
        } else {
          this.providers = filteredUsers;
        }
      }
      if (this.filter.users?.value) {
        if (this.anyProviderFilter) {
          this.providers = this.providers.filter(
            user => user.value == this.filter.users.value
          );
        } else {
          this.providers = [this.filter.users];
        }
      }
    },
    async searchEocs({ search, loading }) {
      const s = search.trim();
      if (this.searchEocPhraseLength < 3 && s.length < 3) {
        return;
      }

      if (this.searchEocPhraseLength >= 3 && s.length < 3) {
        this.searchEocPhraseLength = s.length;
        loading(true);
        await this.fetchEocs(search);
        loading(false);
        return;
      }

      this.searchEocPhraseLength = s.length;

      if (this.lastTimeoutEocs) {
        clearTimeout(this.lastTimeoutEocs);
        this.lastTimeoutEocs = null;
      }

      this.eocs = [];

      this.lastTimeoutEocs = setTimeout(async () => {
        loading(true);
        const response = await eocServer.getAllEocMinimal(
          {
            searchPhrase: search,
            eocStatus:
              !search || search.length == 0 ? ["Active", "Pending"] : [],
            page: 1,
            pageSize: 50
          },
          { "Hide-Loading": true }
        );
        this.eocs = response.episodesOfCare.map(eoc => ({
          value: eoc.id,
          label: this.formatEocObj(eoc),
          data: eoc
        }));
        loading(false);
      }, 1000);
    },
    addScheduleEvent(defaultData = null) {
      this.eventTypeSelectorDefaultData = defaultData;
      this.showEventTypeSelectorModal = true;
    },
    selectEditor(editor, location) {
      if (editor === "appointment") {
        this.appointmentEditor.id = null;
        this.appointmentEditor.show = true;
        this.appointmentEditor.providerId = this.filter.users?.value;
        this.appointmentEditor.defaultData = this.eventTypeSelectorDefaultData;
      } else if (editor === "groupSession") {
        this.groupEditor.id = null;
        this.groupEditor.show = true;
        this.groupEditor.providerId = this.filter.users?.value;
        this.groupEditor.defaultData = this.eventTypeSelectorDefaultData;
      } else if (editor === "loc") {
        this.locEditor.id = null;
        this.locEditor.show = true;
        this.locEditor.defaultData = this.eventTypeSelectorDefaultData;
        this.locEditor.providerId = this.filter.users?.value;
      } else {
        this.userEventEditor.id = null;
        this.userEventEditor.show = true;
        this.userEventEditor.defaultData = this.eventTypeSelectorDefaultData;
      }

      if (location) {
        this.location = location?.value;
      }
    },
    async confirmIfAppoitmentsColide(
      formData,
      eventRecord,
      newStartDate,
      newEndDate
    ) {
      if (eventRecord.data.eventData.type.code == "appointment") {
        var data = {
          ...eventRecord.data.eventData,
          type: eventRecord.data.eventData.type.id,
          users: eventRecord.data.eventData.users.map(user => user.id),
          episodesOfCare: eventRecord.data.eventData.episodesOfCare.map(eoc => ({
            ...eoc,
            id: eoc.episodeOfCare.id,
          })),
          startDateTime: this.formatDateTimeSql(newStartDate),
          endDateTime: this.formatDateTimeSql(newEndDate)
        }
        const DoubleBooked = await scheduleEventServer.checkForDoubleBookedEvent(data);
        const DoubleBookedEoc = await scheduleEventServer.checkForDoubleBookedEventEoc(data);
        const appointment = this.scheduleEvents.find(
          appointment => appointment.id === eventRecord.data.eventData.id
        );
        if (DoubleBooked || DoubleBookedEoc) {
          let confirmed = false;
          if (DoubleBooked && DoubleBookedEoc) {
            confirmed = await this.$dialog
              .confirm(
                {
                  title: "This provider and this patient already have an appointment at this time."
                },
                {
                  view: "multiple-actions",
                  cancelText: "Cancel",
                  options: [{ value: true, label: "Save" }]
                }
              )
              .catch(() => this.fetchData());
          } else if (DoubleBooked) {
            confirmed = await this.$dialog
              .confirm(
                {
                  title: "This provider already have an appointment at this time."
                },
                {
                  view: "multiple-actions",
                  cancelText: "Cancel",
                  options: [{ value: true, label: "Save" }]
                }
              )
              .catch(() => this.fetchData());
          } else if (DoubleBookedEoc) {
            confirmed = await this.$dialog
              .confirm(
                {
                  title: "This patient already have an appointment at this time."
                },
                {
                  view: "multiple-actions",
                  cancelText: "Cancel",
                  options: [{ value: true, label: "Save" }]
                }
              )
              .catch(() => this.fetchData());
          }
          if (!confirmed) {
            formData.startDateTime = this.formatDateTimeSql(
              appointment.startDateTime
            );
            formData.endDateTime = this.formatDateTimeSql(
              appointment.endDateTime
            );
          }
          return confirmed;
        }
      }
      return true;
    },
    export() {
      this.showReportRequestsModal = true;
    },
    onModifyAddEditUserEvent() {
      this.userEventEditor.show = false;
      this.fetchData();
    },
    onModifyAddEditScheduleEvent() {
      this.appointmentEditor.show = false;
      this.fetchData();
    },
    onModifyAddEditLocEvent() {
      this.locEditor.show = false;
      this.fetchData();
    },
    onModifyAddEditGroup() {
      this.groupEditor.show = false;
      this.fetchData();
    },
    onModifyGroupNotes() {
      this.groupNotesEditor.show = false;
      this.participantNotesEditor.show = false;
      this.fetchData();
    },
    onModifyGroupSessionViewModal() {
      this.fetchData();
    },
    onHiddenGroupNotes() {
      this.participantNotesEditor.show = false;
    },
    openDocumentAddEdit(
      eocId,
      patientId,
      formId,
      scheduleEventId,
      scheduleEventParticipantId,
      startDateTime
    ) {
      this.documentEditor.eocId = eocId;
      this.documentEditor.clientId = patientId;
      this.documentEditor.formId = formId;
      this.documentEditor.submitId = null;
      this.documentEditor.scheduleEventId = scheduleEventId;
      this.documentEditor.scheduleEventParticipantId = scheduleEventParticipantId;
      this.documentEditor.effectiveDateTime = startDateTime;
      this.documentEditor.show = true;
    },
    openDocumentFileAddEdit(
      eocId,
      patientId,
      formId,
      scheduleEventId,
      scheduleEventParticipantId,
      startDateTime
    ) {
      this.documentEditor.eocId = eocId;
      this.documentEditor.clientId = patientId;
      this.documentEditor.formId = formId;
      this.documentEditor.submitId = null;
      this.documentEditor.scheduleEventId = scheduleEventId;
      this.documentEditor.scheduleEventParticipantId = scheduleEventParticipantId;
      this.documentEditor.effectiveDateTime = startDateTime;
      this.docFileAddEditModal = true;
    },
    onModifyDocument() {
      this.docFileAddEditModal = false;
      this.fetchScheduleEvents();
      this.fetchAppointmentRequests();
    },
    openDocumentViewer(doc) {
      if (doc.mode == "File") {
        const url = formSumitterServer.viewUrl(doc.id);
        window.open(url, "_blank");
      } else {
        this.documentViewModal.id = doc.id;
        this.documentViewModal.show = true;
      }
    },
    onModifydocumentEditor() {
      this.documentEditor.show = false;
      this.fetchScheduleEvents();
      this.fetchAppointmentRequests();
    },
    onModifydocumentViewer() {
      this.documentViewModal.show = false;
      this.fetchScheduleEvents();
      this.fetchAppointmentRequests();
    },
    async fetchEocs(search) {
      const response = await eocServer.getAllEocMinimal(
        {
          searchPhrase: "",
          eocStatus: !search || search.length == 0 ? ["Active", "Pending"] : [],
          page: 1,
          pageSize: 50
        },
        {
          "Hide-Loading": true
        }
      );
      this.eocs = response.episodesOfCare.map(eoc => ({
        value: eoc.id,
        label: this.formatEocObj(eoc),
        data: eoc
      }));
    },
    async fetchUsers() {
      const users = await userServer.getMinimalUsers();
      this.users = users.map(user => ({
        value: user.id,
        label: this.formatUser(user),
        data: user
      }));
    },
    async fetchServices() {
      const services = await serviceServer.query({
        type: "Service"
      });
      this.services = services.map(service => ({
        value: service.id,
        label: `${
          service.billingCodes[0] ? service.billingCodes[0].cptCode + " - " : ""
        } ${service.name}`,
        data: service,
        costPerUnit: service.costPerUnit,
        numberOfUnits: 1,
        color: service.color != null ? service.color : null
      }));
    },
    async fetchRooms() {
      const rooms = await roomServer.query();
      this.rooms = rooms.map(room => ({
        value: room.id,
        label: room.name,
        data: room
      }));
    },
    async fetchInsuracesCompanies() {
      const insuranceCompanies = await insuranceCompanyServer.query({
        pageSize: 10000
      });
      this.insuranceCompanies = insuranceCompanies.records.map(ic => ({
        value: ic.id,
        label: ic.name,
        data: ic
      }));
    },
    async fetchProvidersServices() {
      const services = await serviceServer.query({
        type: "Service"
      });
      this.providersServices = services.map(service => ({
        value: service.id,
        label: `${
          service.billingCodes[0] ? service.billingCodes[0].cptCode + " - " : ""
        } ${service.name}`,
        data: service
      }));
    },
    eventRenderer({ eventRecord }) {
      if (eventRecord.data.eventData?.type?.code === "nonAvailability") {
        return ``;
      }
      const iconClass =
        "fa-file " +
        (eventRecord.data.eventData?.documentationCompleted
          ? "text-success"
          : "text-danger");
      let title = eventRecord.name;
      let badge = "";
      if (eventRecord.data.eventData?.type?.code == "groupSession") {
        title =
          '<span class="badge badge-primary little-badge mr-1">Group</span>';
        badge = title;
      } else if (eventRecord.data.eventData?.type?.code == "other") {
        title = `<span class="badge badge-primary little-badge mr-1">Other</span>${eventRecord.data.eventData?.title}`;
      } else if (eventRecord.data.eventData?.type?.code == "loc") {
        badge = `<span class="badge badge-primary little-badge mr-1">${(eventRecord
          .data.eventData?.services.length > 0
          ? eventRecord.data.eventData?.services[0].service.name
          : ""
        )
          .substr(0, 3)
          .toUpperCase()}</span>`;
      } else if (
        eventRecord.data.eventData?.type?.code == "appointmentRequest"
      ) {
        badge =
          '<span class="badge badge-danger little-badge mr-1">Hold</span>';
        title = `${eventRecord.name} with`;
      }
      const eventName = eventRecord.name
        ? `<span class="event-name-label">${
            eventRecord.data.eventData?.type?.code !== "appointmentRequest" &&
            eventRecord.data.eventData?.type?.code !== "other" &&
            eventRecord.data.eventData?.type?.code !== "loc"
              ? `<i class="fa ${iconClass}"></i>`
              : ""
          } ${title}</span>`
        : "";

      let user = "";
      if (
        eventRecord.data.eventData?.type?.code != "other" &&
        eventRecord.data.eventData?.type?.code != "loc" &&
        eventRecord.data.eventData?.type?.code != "nonAvailability"
      ) {
        user =
          eventRecord.data.eventData?.users &&
          eventRecord.data.eventData?.users.length > 0 &&
          eventRecord.data.eventData?.users[0]
            ? this.formatUser(eventRecord.data.eventData?.users[0])
            : eventRecord.data.eventData?.type?.code == "appointmentRequest" &&
              eventRecord.data.eventData.provider
            ? this.formatUser(eventRecord.data.eventData?.provider)
            : "<span class='text-danger'> No provider selected </span>";
      }

      const preposition =
        eventRecord.data.eventData?.type?.code != "other" &&
        eventRecord.data.eventData?.type?.code != "loc"
          ? "<i class='mr-1'>with</i>"
          : "";

      const time = this.formatTimeOnly(eventRecord.data.startDate);

      if (eventRecord.data.eventData?.allDay) {
        return `<div style="font-size:13px;">${badge}${eventName} ${preposition}${user}</div>`;
      } else if (
        eventRecord.data.eventData?.type?.code == "appointmentRequest"
      ) {
        return `<div class="d-flex align-items-md-center align-items-lg-center flex-sm-wrap" style="font-size:13px;height:100%;display:flex;">${badge}${eventName} ${user}, ${time}</div>`;
      }
      return `<div style="font-size:13px;">
        <div>${eventName}, ${time}</div>
        ${preposition}${user}
      </div>`;
    },
    monthEventRenderer({ eventRecord }) {
      if (eventRecord.data.eventData?.type?.code === "nonAvailability") {
        return ``;
      }
      let user = "";
      if (
        eventRecord.data.eventData?.type?.code != "other" &&
        eventRecord.data.eventData?.type?.code != "nonAvailability"
      ) {
        user =
          eventRecord.data.eventData?.users &&
          eventRecord.data.eventData?.users.length > 0 &&
          eventRecord.data.eventData?.users[0]
            ? this.formatUser(eventRecord.data.eventData?.users[0])
            : eventRecord.data.eventData?.type?.code == "appointmentRequest" &&
              eventRecord.data.eventData.provider
            ? this.formatUser(eventRecord.data.eventData?.provider)
            : "<span class='text-danger'> No provider selected </span>";
      }
      const iconClass =
        "fa-file " +
        (eventRecord.data.eventData?.documentationCompleted
          ? "text-success"
          : "text-danger");
      let title =
        eventRecord.data.eventData?.type.code != "groupSession"
          ? eventRecord.name
          : user;
      let badge = "";
      if (eventRecord.data.eventData?.type?.code == "groupSession") {
        badge = '<span class="badge badge-primary little-badge mr-1">G</span>';
      } else if (eventRecord.data.eventData?.type?.code == "other") {
        badge = '<span class="badge badge-primary little-badge mr-1">O</span>';
      } else if (eventRecord.data.eventData?.type?.code == "loc") {
        badge = `<span class="badge badge-primary little-badge mr-1">${(eventRecord
          .data.eventData?.services.length > 0
          ? eventRecord.data.eventData?.services[0].service.name
          : ""
        )
          .substr(0, 3)
          .toUpperCase()}</span>`;
      } else if (
        eventRecord.data.eventData?.type?.code == "appointmentRequest"
      ) {
        badge =
          '<span class="badge badge-danger little-badge mr-1">HOLD</span>';
      }
      const eventName = eventRecord.name
        ? `<span class="event-name-label">${
            eventRecord.data.eventData?.type?.code !== "appointmentRequest" &&
            eventRecord.data.eventData?.type?.code !== "other" &&
            eventRecord.data.eventData?.type?.code !== "loc"
              ? `<i class="fa ${iconClass}"></i>`
              : ""
          } ${title}</span>`
        : "";

      const time = this.formatTimeOnly(eventRecord.data.startDate);

      if (eventRecord.data.eventData.allDay) {
        return `<div style="font-size:13px;">${badge}${eventName}</div>`;
      }

      return `<div class="d-flex align-items-center" style="font-size:13px;">
          ${badge}${eventName},&nbsp;${time}
      </div>`;
    },
    statusDropdownRenderer(participant, chargedEncounter) {
      const currentStatus = this.statuses.find(
        u => u.value == participant.scheduleEventStatus.id
      );
      const color = currentStatus.data.color;
      const bgColor = lightenDarkenColor(color, 85);

      const selectDataId = `data-id="${participant.id}"`;
      const selectClass = `class="custom-select status-select"`;
      const selectStyle = `
        style="color: ${color};
        background-color: ${bgColor};
        font-weight: bold;
        max-width: 100%;
        width: 131px;
        font-size:14px;"`;

      return `<select id="${participant.id + currentStatus.data.name}" ${
        chargedEncounter && !this.canEditChargedEvents ? `disabled` : ``
      } ${selectDataId} ${selectClass} ${selectStyle}>
        ${this.statuses.map(
          status => `
          <option value="${status.value}"
            ${status == currentStatus ? "selected" : ""}
             style="color: ${status.data.color};
                    background-color: white;
                    font-weight: bold;">
            ${status.label}
          </option>
        `
        )}
      </select>`;
    },
    checkButtonRenderer(participant, chargedEncounter) {
      const buttonDataId = `data-id="${participant.id}"`;
      const buttonDataCheckedIn = `data-checkedin="${participant.checkedIn}"`;
      const buttonClass = `class="btn btn-checkedin ${
        participant.checkedIn ? "btn-success" : "btn-outline-success"
      }"`;
      const innerText = participant.checkedIn ? "Check Out" : "Check In";

      return `
      <button type="button" ${
        chargedEncounter && !this.canEditChargedEvents ? `disabled` : ``
      } ${buttonDataId} ${buttonDataCheckedIn} ${buttonClass}">
        <i class="fas fa-check mr-1"></i> ${innerText}
      </button>`;
    },
    async fetchDocsByEOC(search, page, stackResult) {
      this.clientSearchChanged = true;
      if (this.lastTimeout) {
        clearTimeout(this.lastTimeout);
        this.lastTimeout = null;
      }
      this.lastTimeout = setTimeout(async () => {
        if (!search || search.length == 0 || search.length >= 3) {
          this.attachDocPagination.page = 0;
          const optionsResult = await documentServer.queryImproved(
            {
              searchPhrase: search,
              episodeOfCareId: [this.eocId],
              formId: [],
              status: [],
              fromDate: null,
              toDate: null,
              effectiveFromDate: null,
              effectiveToDate: null,
              createdBy: [],
              page: page,
              pageSize: this.attachDocPagination.pageSize,
              orderBy: "creationDate",
              orderByDescending: true,
              category: [],
              eocStatus:
                !search || search.length == 0 ? ["Active", "Pending"] : []
            },
            {
              "Hide-Loading": true
            }
          );
          this.attachDocPagination.count = optionsResult.count
            ? optionsResult.count
            : 0;
          this.attachDocPagination.page = page ? page : 0;
          this.isLastPage();
          if (stackResult) {
            let newValues = optionsResult.documents
              .filter(doc => doc.mode != "Group")
              .map(doc => ({
                value: doc.id,
                label: `Ref# ${doc.documentRefNumber} | ${doc.form.name}`,
                data: doc
              }));
            this.documentsByEoc = this.documentsByEoc.concat(newValues);
          } else {
            this.documentsByEoc = optionsResult.documents
              .filter(doc => doc.mode != "Group")
              .map(doc => ({
                value: doc.id,
                label: `Ref# ${doc.documentRefNumber} | ${doc.form.name}`,
                data: doc
              }));
          }
          this.clientSearchChanged = false;
        } else {
          this.clientSearchChanged = false;
          this.clientOptions = [];
        }
      }, 1000);
    },
    isLastPage() {
      let totalPages = Math.ceil(
        this.attachDocPagination.count / this.attachDocPagination.pageSize
      );
      let result = totalPages - 1 == this.attachDocPagination.page;
      this.attachDocPagination.lastPage = result;
    },
    async attachForm() {
      const scheduleEvent = this.scheduleEvents.find(
        u => u.id == this.selectedScheduleEventId
      );
      const participant = scheduleEvent.episodesOfCare[0];
      const eoc = participant.episodeOfCare;
      if (this.selectedForm.value != null) {
        this.showAttach = true;
        if (this.selectedDocType === "standard") {
          this.openDocumentAddEdit(
            eoc.id,
            eoc.patient.id,
            this.selectedForm.value,
            this.selectedScheduleEventId,
            participant.id,
            scheduleEvent.startDateTime
          );
        } else {
          this.openDocumentFileAddEdit(
            eoc.id,
            eoc.patient.id,
            this.selectedForm.value,
            this.selectedScheduleEventId,
            participant.id,
            scheduleEvent.startDateTime
          );
        }
      } else {
        this.showAttach = false;
      }
    },
    async attachDocument() {
      await scheduleEventServer.attachDocuments(
        this.selectedScheduleEventId,
        this.selectedDocuments
      );
      this.fetchData();
    },
    async refreshData() {
      this.fetchData();
    },
    async updateAppointments() {
      try {
        this.formData.modification = this.selectedOption;
        await scheduleEventServer.updateDates(this.formData.id, this.formData);
        this.showAlertSuccess();
      } catch (error) {
        await this.showAlertError({
          message: error.response.data.message
        });
      } finally {
        this.fetchData();
      }
    },
    async resendInvitation() {
      await scheduleEventServer.resendInvitation(
        this.selectedScheduleEventId,
        this.eocId
      );
    },
    isBillingDayLOCRestricted() {
      return this.billingRestriction;
    },
    createNonAvailableTimes: function(
      startDateTime,
      endDateTime,
      availableTimes
    ) {
      if (!availableTimes?.length) return [];

      let notAvailableTimes = [];
      const providerId = availableTimes[0].providerId;
      notAvailableTimes.push({
        startDateTime: startDateTime,
        endDateTime: "",
        providerId
      });
      for (const availability of availableTimes) {
        notAvailableTimes = this.getNonAvailableTimesSplitInDays(
          notAvailableTimes,
          availability.startDateTime,
          providerId
        );

        notAvailableTimes[notAvailableTimes.length - 1].endDateTime =
          availability.startDateTime;
        notAvailableTimes.push({
          startDateTime: availability.endDateTime,
          endDateTime: "",
          providerId
        });
      }
      notAvailableTimes = this.getNonAvailableTimesSplitInDays(
        notAvailableTimes,
        endDateTime,
        providerId
      );
      notAvailableTimes[notAvailableTimes.length - 1].endDateTime = endDateTime;
      return notAvailableTimes;
    },
    getNonAvailableTimes() {
      let startDateTime = this.filter.startDate + "T00:00:00";
      let endDateTime = this.filter.endDate + "T23:59:59";

      let notAvailableTimes = [];
      if (this.filter.users && this.filter.users?.value) {
        const availableTime = this.filterProviderAvailabilities();
        if (
          this.filter.users?.data.hasAvailabilitiesConfigured &&
          availableTime.length == 0
        ) {
          availableTime.push({
            startDateTime: "2023-01-20T00:00:00",
            endDateTime: "2023-01-20T23:00:00",
            providerId: this.filter.users?.value
          });
        }
        notAvailableTimes = this.createNonAvailableTimes(
          startDateTime,
          endDateTime,
          availableTime
        );
      } else if (this.isByProviderViewActive) {
        let availableTimesByProvider = {};
        this.providerAvailabilities.forEach(pa => {
          availableTimesByProvider[pa.provider.id]
            ? availableTimesByProvider[pa.provider.id].push(pa)
            : (availableTimesByProvider[pa.provider.id] = [pa]);
        });

        const providerUsers = this.providerList;
        for (let index = 0; index < providerUsers.length; index++) {
          const providerUser = providerUsers[index].data;
          let availableTimes = availableTimesByProvider[providerUser.id];
          if (!availableTimes) {
            availableTimes = [];
            if (providerUser.hasAvailabilitiesConfigured) {
              availableTimes.push({
                startDateTime: "2023-01-20T00:00:00",
                endDateTime: "2023-01-20T23:00:00",
                providerId: providerUser.id
              });
            }
          } else {
            availableTimes = this.filterProviderAvailabilities(availableTimes);
          }

          notAvailableTimes.push(
            ...this.createNonAvailableTimes(
              startDateTime,
              endDateTime,
              availableTimes
            )
          );
        }
      }
      this.providerNonAvailabilities = notAvailableTimes;
      return notAvailableTimes;
    },
    filterProviderAvailabilities(availabilities = null) {
      availabilities = availabilities || this.providerAvailabilities;
      const initialAvailabilities = availabilities.map(pa => {
        return {
          startDateTime: pa.startDateTime,
          endDateTime: pa.endDateTime,
          providerId: pa.provider.id
        };
      });

      const providerUsers = this.providerList;
      for (let index = 0; index < providerUsers.length; index++) {
        const providerUser = providerUsers[index].data;
        if (providerUser.hasAvailabilitiesConfigured) {
          initialAvailabilities.push({
            startDateTime: "2023-01-20T00:00:00",
            endDateTime: "2023-01-20T23:59:59",
            providerId: providerUser.id
          });
        }
      }
      if (initialAvailabilities.length == 0) {
        return initialAvailabilities;
      }
      let finalProviderAvailabilities = [initialAvailabilities[0]];
      for (let index = 1; index < initialAvailabilities.length; index++) {
        const initialAvailability = initialAvailabilities[index];

        const lastAvailability =
          finalProviderAvailabilities[finalProviderAvailabilities.length - 1];
        if (
          initialAvailability.startDateTime <= lastAvailability.endDateTime &&
          initialAvailability.endDateTime >= lastAvailability.endDateTime
        ) {
          lastAvailability.endDateTime = initialAvailability.endDateTime;
          finalProviderAvailabilities[
            finalProviderAvailabilities.length - 1
          ] = lastAvailability;
        } else if (
          initialAvailability.startDateTime > lastAvailability.endDateTime
        ) {
          finalProviderAvailabilities.push(initialAvailability);
        }
      }
      return finalProviderAvailabilities;
    },
    getNonAvailableTimesSplitInDays(
      notAvailableTimes,
      nextStartTime,
      providerId
    ) {
      let lastUnavailableStartDateTime = moment(
        notAvailableTimes[notAvailableTimes.length - 1].startDateTime
      );
      let availabilityStartDateTime = moment(nextStartTime);
      while (
        lastUnavailableStartDateTime.format("YYYY-MM-DD") <
        availabilityStartDateTime.format("YYYY-MM-DD")
      ) {
        notAvailableTimes[notAvailableTimes.length - 1].endDateTime =
          lastUnavailableStartDateTime.format("YYYY-MM-DD") + "T23:59:59";
        lastUnavailableStartDateTime.add(1, "day");
        notAvailableTimes.push({
          startDateTime:
            lastUnavailableStartDateTime.format("YYYY-MM-DD") + "T00:00:00",
          endDateTime: "",
          providerId: providerId
        });
      }
      return notAvailableTimes;
    },
    viewpaint({ source }) {
      this.isMonthViewActive = source.modeName == "month";
      this.isByProviderViewActive = source.modeName == "byProvider";
      this.currentCalendarViewIndex(source.modeName);
    },
    dateRangeRequested() {
      if (this.isByProviderViewActive) {
        this.insertPlaceOfService();
      }
    },
    insertPlaceOfService() {
      const resourceMetaWidgets = document.getElementsByClassName(
        "place-of-service-widget"
      );
      let id = "";
      for (let widget of resourceMetaWidgets) {
        widget.innerHTML = "";
        id = widget.id.replace("container-for-pos_", "");
        let resource = this.calendarResources.find(r => r.id == id);
        if (resource && resource.providerAvailabilities)
          widget.innerHTML = this.getHTMLForPoS(resource);
      }
      document.removeEventListener("click", this.onClickMorePlaceOfService);
      document.addEventListener("click", this.onClickMorePlaceOfService);
    },
    insertLoadMoreLogic() {
      const loadMoreContainer = document.querySelector(
        '[data-view-resource-id="-2"]'
      );
      if (loadMoreContainer) {
        if (!loadMoreContainer.querySelector(".load-more-provider-container")) {
          var children = loadMoreContainer.children;
          for (var i = 0; i < children.length; i++) {
            var child = children[i];
            child.style.visibility = "hidden";
          }
          const loadMoreNode = document.createElement("div");
          loadMoreNode.classList.add("load-more-provider-container");
          loadMoreNode.style = "position: absolute;top: 350px;width: 100%";
          loadMoreNode.innerHTML =
            "<div class='d-flex flex-column justify-content-start align-items-center'><button type='button' class='btn btn-outline-secondary load-more-providers-button' style='padding: 10px 30px !important; border-radius: 0px;'>Load more providers...</button><a href='#' class='mt-4 load-all-providers-link' style='font-size:12px'> Load all providers...</a></div>";

          loadMoreContainer.appendChild(loadMoreNode);
          document.removeEventListener("click", this.onClickLoadMoreProviders);
          document.addEventListener("click", this.onClickLoadMoreProviders);
        }
      }
    },
    onClickLoadMoreProviders(event) {
      if (!this.showing || !this.isByProviderViewActive) return;
      let target = event.target;
      const loadMore = document.querySelector(
        '[data-view-resource-id="-2"] .load-more-providers-button'
      );
      if (loadMore && loadMore.contains(target)) {
        this.loadMoreProviders();
      }
      const loadAll = document.querySelector(
        '[data-view-resource-id="-2"] .load-all-providers-link'
      );
      if (loadAll && loadAll.contains(target)) {
        this.loadAllProviders();
      }
    },
    onClickMorePlaceOfService(event) {
      if (!this.showing || !this.isByProviderViewActive) return;

      let target = event.target;
      const moreAnchors = document.getElementsByClassName(
        "more_provider_availabilities_anchor"
      );
      for (let a of moreAnchors) {
        const moreProviderAvailabilities = document.getElementById(
          a.id.replace("_anchor", "")
        );
        if (a.contains(target) || moreProviderAvailabilities.contains(target))
          moreProviderAvailabilities.classList.remove("invisible");
        else moreProviderAvailabilities.classList.add("invisible");
      }
    },
    beforeDragCreateEnd({ eventRecord }) {
      const eventStartDateTime = moment(eventRecord.data.startDate).format(
        "YYYY-MM-DDTHH:mm:ss"
      );
      const eventEndDateTime = moment(eventRecord.data.endDate).format(
        "YYYY-MM-DDTHH:mm:ss"
      );
      const notAvailable = this.providerNonAvailabilities.filter(item => {
        if (
          this.isByProviderViewActive &&
          item.providerId !== eventRecord.data.resourceId
        )
          return false;
        if (
          (item.startDateTime <= eventStartDateTime &&
            item.endDateTime >= eventEndDateTime) ||
          (eventStartDateTime > item.startDateTime &&
            eventStartDateTime < item.endDateTime) ||
          (eventEndDateTime > item.startDateTime &&
            eventEndDateTime < item.endDateTime)
        ) {
          return item;
        }
      });

      if (notAvailable.length > 0) {
        this.showAlertError({
          message: "This provider is not available at this date and time."
        });
        return false;
      }
      return true;
    },
    confirmResend(firstName, lastName, eventId, eocId) {
      this.$dialog
        .confirm(
          {
            title: `Are you sure you want to resend the invitation for patient ${firstName} ${lastName}?`
          },
          {
            view: "multiple-actions",
            options: [
              { value: true, label: "Yes" },
              { value: false, label: "No" }
            ]
          }
        )
        .then(async value => {
          if (value.data.value) {
            this.selectedScheduleEventId = eventId;
            this.eocId = eocId;
            this.resendInvitation();
          }
        });
    },
    showInvoicePaymentModal(data) {
      this.paymentAddModal.invoiceId = data.id;
      this.paymentAddModal.patient = {
        patientId: data.episodeOfCare.patientId,
        name: this.formatClient(
          data.episodeOfCare.patient.firstName,
          data.episodeOfCare.patient.middleName,
          data.episodeOfCare.patient.preferredName ?? "",
          data.episodeOfCare.patient.lastName
        )
      };
      this.paymentAddModal.show = true;
    },
    async refetchEvent(scheduleEventId) {
      try {
        const eventData = await scheduleEventServer.findMinimal(
          scheduleEventId,
          {
            "Hide-Loading": true
          }
        );

        const eventIndex = this.scheduleEvents.findIndex(
          event => event.id === scheduleEventId
        );

        if (eventIndex !== -1) {
          const updatedEvents = [
            ...this.scheduleEvents.slice(0, eventIndex),
            { ...eventData },
            ...this.scheduleEvents.slice(eventIndex + 1)
          ];

          this.scheduleEvents = [...updatedEvents];
        }
      } catch (error) {
        console.error("Error refreshing event from portal:", error);
      }
    },
    async getTooltipHtml(scheduleEventId) {
      this.scheduleEvent = await scheduleEventServer.get(scheduleEventId, {
        "Hide-Loading": true
      });
      const eventData = this.scheduleEvent;
      const formatDocument = f => {
        const metadata = JSON.stringify({
          eventId: eventData.id,
          id: f.id,
          formId: f.formId,
          document: f.document
        });

        const dataAttributes = `data-appointment-form='${metadata}'`;

        const cssClass =
          !f.document || f.document.status == "Draft"
            ? "fa fa-clock-o text-danger"
            : f.document.status == "Pending"
            ? "fa fa-clock-o text-warning"
            : "fa fa-check text-success";
        let hasEntryAccess = this.hasCurrentUserDocumentPermission(
          f.formId,
          "hasEntryAccess"
        );
        const linkClasses = hasEntryAccess
          ? "text-primary text-underline"
          : "text-secondary text-none disabled";

        const result = `<i style="font-size: 19px;" class="${cssClass}"></i>
                <a class="${linkClasses} ml-1" href="#" ${dataAttributes}>
                  ${f.form.name}
                </a>
                ${
                  hasEntryAccess
                    ? '<i style="font-size: 19px;" class="fa fa-times text-danger ml-2 hover-pointer"></i>'
                    : ""
                }
                `;

        return `<div class="d-flex w-100 justify-content-start align-items-center">${
          f.isEnabledInScheduleEventLocation || f.document
            ? result
            : `<span class='ml-4'>${f.form.name}</span>`
        }</div>`;
      };

      const sum = xs => xs.reduce((a, x) => a + x, 0);
      let insurancesData = [];
      eventData.billingInfo &&
        eventData.billingInfo?.invoices?.forEach(item => {
          insurancesData.push(`<div>
                    <a class="text-primary ml-1" href="#" id="show-client-invoice_${
                      item.id
                    }"
                    data-invoice-id='${item.id}'>Invoice #${item.refNumber}</a>
                  </div>
                  <div class="tooltip-value px-2 m-1">
                    ${this.toCurrencyValue(item.totalAmount - item.amountPaid)}
                    <span style="font-size:10px; padding: 2px 10px;" class="badge-v2 ml-2 badge-danger">Unpaid</span>
                  </div>
                  <div class="tooltip-value px-2 m-1">
                    ${this.toCurrencyValue(item.amountPaid)}
                    <span style="font-size:10px; padding: 2px 10px;" class="badge-v2 ml-2 badge-success">Paid</span>
                  </div>
                `);
        });
      const invoicedAmount =
        eventData.billingInfo && eventData.billingInfo.invoices?.length
          ? Math.max(
              sum(eventData.billingInfo.invoices.map(x => x.totalAmount)),
              0
            )
          : eventData.billingInfo
          ? eventData.billingInfo.clientAmount
          : 0;
      let billingInfoFormatted = "";
      if (this.hasCurrentUserPermissionAccess("others", "patientBillingInfo"))
        billingInfoFormatted = `
            <div class="tooltip-item" id="billing" style="display: ${
              eventData?.billingInfo ? "block" : "none"
            };">
              <div>
                <i class="b-fa b-fa-dollar-sign"></i> Billing
              </div>
              <div class="tooltip-value px-2 m-1" id="insuranceType">
                Billing Type: ${
                  eventData.billingInfo?.insuranceType == 1
                    ? "Insurance"
                    : "Self-Pay"
                }
              </div>
              <div class="tooltip-value px-2 m-1" id="totalAmount">
                Fee: ${this.toCurrencyValue(
                  eventData.billingInfo?.totalAmount ?? 0
                )}
              </div>
              <div class="tooltip-value px-2 m-1" id="insuranceAmount">
                Insurance: ${this.toCurrencyValue(
                  Math.max(
                    eventData.billingInfo?.totalAmount - invoicedAmount,
                    0
                  )
                )}
              </div>
              <div class="tooltip-value px-2 m-1" id="clientAmount">
                Client: ${
                  eventData.billingInfo?.clientAmount
                    ? this.toCurrencyValue(eventData.billingInfo?.clientAmount)
                    : 0
                }
              </div>
              ${insurancesData.length > 0 ? insurancesData.join("\n") : ""}
                  ${
                    this.enablePaymentSystem &&
                    eventData.billingInfo?.clientAmount > 0 &&
                    eventData.billingInfo?.uninvoicedAmount > 0
                      ? `<div>
                    <a class="text-primary ml-1" href="#" id="create-client-invoice"
                    data-encounter-id='${
                      eventData.billingInfo?.encounterId
                    }' data-eoc-id='${
                          eventData.episodesOfCare.length > 0
                            ? eventData.episodesOfCare[0].episodeOfCare.id
                            : null
                        }'>+ Create client invoice</a>
                  </div>`
                      : ``
                  }
            </div>
            `;
      if (eventData.type.code == "appointment") {
        const chargedEncounter = eventData.billingInfo?.encounterSubmited;
        const participant = eventData.episodesOfCare[0];
        return `
            <div class="schedule-event-tooltip-data"></div>
            <div class="d-flex justify-content-between align-items-center mt-2 mb-1">
              ${this.statusDropdownRenderer(
                eventData.episodesOfCare[0],
                chargedEncounter
              )}
              ${this.checkButtonRenderer(
                eventData.episodesOfCare[0],
                chargedEncounter
              )}
            </div>
            ${
              !this.selectedLocation
                ? `<div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-building"></i> Location
              </div>
              <div
                class="tooltip-value px-2 ml-1"
                style="white-space: nowrap;"
              >
                ${eventData.location.name}
              </div>
              <div class="tooltip-value px-2 ml-1">
                ${eventData.location.timeZoneDisplayName}
                </i>
              </div>
            </div>`
                : ""
            }
            <div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-clock"></i> Date, time and duration
              </div>
              <div class="tooltip-value px-2 m-1">
                ${this.formatDateTimeDuration(
                  eventData.startDateTime,
                  eventData.endDateTime,
                  eventData.allDay
                )}
              </div>
            </div>
            ${
              eventData.users
                ? `<div class="tooltip-item">
                    <div>
                      <i class="b-fa b-fa-user"></i> Provider
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      ${
                        eventData.users[0]
                          ? this.formatUser(eventData.users[0])
                          : "No provider selected"
                      }
                    </div>
                  </div>`
                : ""
            }
            <div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-user"></i> Patient
              </div>
              <div class="tooltip-value px-2 m-1">
                ${this.formatEocObj(participant.episodeOfCare)}
              </div>

            </div>
            ${this.getBatchesAndAlertTooltip(participant)}
            ${
              eventData.placeOfService
                ? `<div class="tooltip-item">
                    <div>
                      <i class="b-fa b-fa-map-pin"></i> Place of service
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      ${`${eventData.placeOfService.code}-${eventData.placeOfService.name}`}
                    </div>
                  </div>`
                : ""
            }
            ${
              eventData.room
                ? `<div class="tooltip-item">
                    <div>
                      <i class="b-fa b-fa-map-pin"></i> Room
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      ${`${eventData.room.name}`}
                    </div>
                  </div>`
                : ""
            }
            ${
              eventData.reason
                ? `<div class="tooltip-item">
                    <div>
                      <i class="b-fa b-fa-sticky-note"></i> Reason
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      ${eventData.reason}
                    </div>
                  </div>`
                : ""
            }
            <div>
            <a class="text-primary ml-1" href="#" id="resend-invitation" data-event-id='${
              eventData.id
            }'data-eoc-id='${
          participant.episodeOfCare.id
        }'data-patient-firstname='${
          participant.episodeOfCare.patient.firstName
        }'
            data-patient-lastname='${
              participant.episodeOfCare.patient.lastName
            }'
            >Resend invitation to client.</a>
            </div>
            ${
              eventData.zoomMeetingUrl
                ? `<div class="tooltip-item">
                    <div class="d-flex align-items-center pre-wrap">
                      <img src="${require("../../assets/zoom_icon.png")}" width="16" height="16" />
                      <span> Join Zoom Meeting</span>
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      <a href="${
                        eventData.zoomMeetingUrl
                      }" target="_blank" class="text-primary text-underline">Click here for teleconference link.</a>
                      <b-button id="copyButtonLink" data-event-link='${
                        eventData.zoomMeetingUrl
                      }' v-b-tooltip.hover title="Copy link">
                        <i class="far fa-copy" style="width: 16px"></i>
                      </b-button>
                    </div>
                  </div>`
                : ""
            }
           ${
             eventData.teamsStatus == 2
               ? `<div class="tooltip-item">
                    <div class="d-flex align-items-center pre-wrap">
                      <img src="${require("../../assets/teams_icon.png")}" width="25" height="25" />
                      <small> The Teams meeting link will be generated 30 days before the start date.</small>
                    </div>
                  </div>`
               : ""
           }
             ${
               eventData.teamsMeetingUrl
                 ? `<div class="tooltip-item">
                    <div class="d-flex align-items-center pre-wrap">
                      <img src="${require("../../assets/teams_icon.png")}" width="25" height="25" />
                      <span> Join Teams Meeting</span>
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      <a href="${
                        eventData.teamsMeetingUrl
                      }" target="_blank" class="text-primary text-underline">Click here for teleconference link.</a>
                      <b-button id="copyButtonLink" data-event-link='${
                        eventData.teamsMeetingUrl
                      }' v-b-tooltip.hover title="Copy link">
                        <i class="far fa-copy" style="width: 16px"></i>
                      </b-button>
                    </div>
                  </div>`
                 : ""
             }
             ${
                eventData.googleMeetMeetingUrl
                ? `<div class="tooltip-item">
                    <div class="d-flex align-items-center pre-wrap">
                      <img src="${require("../../assets/google_icon.png")}" width="16" height="16" />
                      <span> Join Google Meet Meeting</span>
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      <a href="${
                    eventData.googleMeetMeetingUrl
                }" target="_blank" class="text-primary text-underline">Click here for teleconference link.</a>
                      <b-button id="copyButtonLink" data-event-link='${
                    eventData.googleMeetMeetingUrl
                }' v-b-tooltip.hover title="Copy link">
                        <i class="far fa-copy" style="width: 16px"></i>
                      </b-button>
                    </div>
                  </div>`
                : ""
            }
            <div id="tooltip-item-services">
            ${this.getToolTipServices(eventData)}
            </div>
            <div id="tooltip-item-documents">
            ${this.getToolTipDocuments(eventData)}
            </div> 
            ${billingInfoFormatted}
            `;
      }

      if (eventData.type.code == "groupSession") {
        const formatParticipant = p => {
          const metadata = JSON.stringify({
            eventId: eventData.id,
            participantId: p.id
          });

          const dataAttributes = `data-group-participant='${metadata}'`;
          const dataAttributesResendInvitation = `data-group-participant-resend-invitation='${metadata}'`;

          return `
              <div class="border rounded mb-2">
                <div class="d-flex justify-content-between align-items-center">
                  ${
                    p.linkedDocuments && p.linkedDocuments.length
                      ? `<div>
                        <a href="#" class="text-primary text-underline ml-2" ${dataAttributes}>
                          <i class="fa fa-file ${
                            p.documentationCompleted
                              ? "text-success"
                              : "text-danger"
                          }"></i> ${this.formatEocObj(p.episodeOfCare)}
                        </a>
                        <br/>
                        <a href="#" class="text-primary text-underline ml-2" ${dataAttributesResendInvitation}>
                          Resend invitation to client.
                        </a>
                        </div>
                        `
                      : `<span class="ml-2">
                          ${this.formatEocObj(p.episodeOfCare)}
                        </span>`
                  }
                  <div style="width: 150px" class="text-right">
                    ${this.statusDropdownRenderer(
                      p,
                      eventData.billingInfo?.encounterSubmited
                    )}
                  </div>
                </div>
              </div>
              `;
        };

        return `
            <div class="schedule-event-tooltip-data"></div>
             ${
               !this.selectedLocation
                 ? `<div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-building"></i> Location
              </div>
              <div
                class="tooltip-value px-2 ml-1"
                style="white-space: nowrap;"
              >
                ${eventData.location.name}
              </div>
              <div class="tooltip-value px-2 ml-1">
                ${eventData.location.timeZoneDisplayName}
                </i>
              </div>
            </div>`
                 : ""
             }
            <div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-clock"></i> Date, time and duration
              </div>
              <div class="tooltip-value px-2 m-1">
                ${this.formatDateTimeDuration(
                  eventData.startDateTime,
                  eventData.endDateTime,
                  eventData.allDay
                )}
              </div>
            </div>
            <div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-user"></i> Provider
              </div>
              <div class="tooltip-value px-2 m-1">
                ${
                  eventData.users[0]
                    ? this.formatUser(eventData.users[0])
                    : "No provider selected"
                }
              </div>
            </div>
            ${
              eventData.placeOfService
                ? `<div class="tooltip-item">
                    <div>
                      <i class="b-fa b-fa-map-pin"></i> Place of service
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      ${`${eventData.placeOfService.code}-${eventData.placeOfService.name}`}
                    </div>
                  </div>`
                : ""
            }
            ${
              eventData.room
                ? `<div class="tooltip-item">
                    <div>
                      <i class="b-fa b-fa-map-pin"></i> Room
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      ${`${eventData.room.name}`}
                    </div>
                  </div>`
                : ""
            }
            <div class="tooltip-item">
              <div>
                <i class="fas fa-align-left"></i> Topic
              </div>
              <div class="tooltip-value px-2 m-1">
                ${eventData.topic.type}
              </div>
            </div>
            <div id="tooltip-item-services">
            ${this.getToolTipServices(eventData)}
            </div>
            <div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-user"></i> Facilitators
              </div>
              <div class="tooltip-value px-2 m-1">
                ${
                  eventData.facilitators.length
                    ? eventData.facilitators
                        .map(facilitator => {
                          return `
                      <div class="tooltip-value m-1">
                        ${this.formatUser(facilitator.user)}
                      </div>`;
                        })
                        .join("")
                    : "No facilitator selected"
                }
              </div>
            </div>
            <div class="tooltip-item">
              <div class="d-flex justify-content-between">
                <span><i class="b-fa b-fa-user"></i> Participants</span>
                <small><i>*Click on a patient to open their documents</i></small>
              </div>
              <div class="tooltip-value m-1">
                ${eventData.episodesOfCare
                  .sort((a, b) =>
                    a.episodeOfCare.patient.firstName.localeCompare(
                      b.episodeOfCare.patient.firstName
                    )
                  )
                  .map(formatParticipant)
                  .join("")}
              </div>
            </div>
            ${
              eventData.zoomMeetingUrl
                ? `<div class="tooltip-item">
                    <div class="d-flex align-items-center pre-wrap">
                      <img src="${require("../../assets/zoom_icon.png")}" width="16" height="16" />
                      <span> Join Zoom Meeting</span>
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      <a href="${
                        eventData.zoomMeetingUrl
                      }" target="_blank" class="text-primary text-underline">Click here for teleconference link.</a>
                      <b-button id="copyButtonLink" data-event-link='${
                        eventData.zoomMeetingUrl
                      }' v-b-tooltip.hover title="Copy link">
                        <i class="far fa-copy" style="width: 16px"></i>
                      </b-button>
                    </div>
                  </div>`
                : ""
            }
             ${
               eventData.teamsStatus == 2
                 ? `<div class="tooltip-item">
                    <div class="d-flex align-items-center pre-wrap">
                      <img src="${require("../../assets/teams_icon.png")}" width="25" height="25" />
                      <small> The Teams meeting link will be generated 30 days before the start date.</small>
                    </div>
                  </div>`
                 : ""
             }
            ${
              eventData.teamsMeetingUrl
                ? `<div class="tooltip-item">
                    <div class="d-flex align-items-center pre-wrap">
                      <img src="${require("../../assets/teams_icon.png")}" width="25" height="25" />
                      <span> Join Teams Meeting</span>
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      <a href="${
                        eventData.teamsMeetingUrl
                      }" target="_blank" class="text-primary text-underline">Click here for teleconference link.</a>
                      <b-button id="copyButtonLink" data-event-link='${
                        eventData.teamsMeetingUrl
                      }' v-b-tooltip.hover title="Copy link">
                        <i class="far fa-copy" style="width: 16px"></i>
                      </b-button>
                    </div>
                  </div>`
                : ""
            }
            ${
                eventData.googleMeetMeetingUrl
                ? `<div class="tooltip-item">
                    <div class="d-flex align-items-center pre-wrap">
                      <img src="${require("../../assets/google_icon.png")}" width="16" height="16" />
                      <span> Join Google Meet Meeting</span>
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      <a href="${
                    eventData.googleMeetMeetingUrl
                }" target="_blank" class="text-primary text-underline">Click here for teleconference link.</a>
                      <b-button id="copyButtonLink" data-event-link='${
                    eventData.googleMeetMeetingUrl
                }' v-b-tooltip.hover title="Copy link">
                        <i class="far fa-copy" style="width: 16px"></i>
                      </b-button>
                    </div>
                  </div>`
                : ""
            }
            `;
      }

      if (eventData.type.code == "other") {
        return `
            <div class="schedule-event-tooltip-data"></div>
             ${
               !this.selectedLocation
                 ? `<div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-building"></i> Location
              </div>
              <div
                class="tooltip-value px-2 ml-1"
                style="white-space: nowrap;"
              >
                ${eventData.location.name}
              </div>
              <div class="tooltip-value px-2 ml-1">
                ${eventData.location.timeZoneDisplayName}
                </i>
              </div>
            </div>`
                 : ""
             }
            <div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-clock"></i> Date, time and duration
              </div>
              <div class="tooltip-value px-2 m-1">
                ${this.formatDateTimeDuration(
                  eventData.startDateTime,
                  eventData.endDateTime,
                  eventData.allDay
                )}
              </div>
            </div>
            <div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-users"></i> Users
              </div>
              <div class="tooltip-value px-2 m-1">
                ${eventData.users
                  .map(u => {
                    return `<div>${this.formatUser(u)}</div>`;
                  })
                  .join("")}
              </div>
            </div>
            ${
              eventData.zoomMeetingUrl
                ? `<div class="tooltip-item">
                    <div class="d-flex align-items-center pre-wrap">
                      <img src="${require("../../assets/zoom_icon.png")}" width="16" height="16" />
                      <span> Join Zoom Meeting</span>
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      <a href="${
                        eventData.zoomMeetingUrl
                      }" target="_blank" class="text-primary text-underline">Click here for teleconference link.</a>
                      <b-button id="copyButtonLink" data-event-link='${
                        eventData.zoomMeetingUrl
                      }' v-b-tooltip.hover title="Copy link">
                        <i class="far fa-copy" style="width: 16px"></i>
                      </b-button>
                    </div>
                  </div>`
                : ""
            }
            ${
              eventData.teamsStatus == 2
                ? `<div class="tooltip-item">
                    <div class="d-flex align-items-center pre-wrap">
                      <img src="${require("../../assets/teams_icon.png")}" width="25" height="25" />
                      <small> The Teams meeting link will be generated 30 days before the start date.</small>
                    </div>
                  </div>`
                : ""
            }
            ${
              eventData.teamsMeetingUrl
                ? `<div class="tooltip-item">
                    <div class="d-flex align-items-center pre-wrap">
                      <img src="${require("../../assets/teams_icon.png")}" width="25" height="25" />
                      <span> Join Teams Meeting</span>
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      <a href="${
                        eventData.teamsMeetingUrl
                      }" target="_blank" class="text-primary text-underline">Click here for teleconference link.</a>
                      <b-button id="copyButtonLink" data-event-link='${
                        eventData.teamsMeetingUrl
                      }' v-b-tooltip.hover title="Copy link">
                        <i class="far fa-copy" style="width: 16px"></i>
                      </b-button>
                    </div>
                  </div>`
                : ""
            }
            ${
                eventData.googleMeetMeetingUrl
                ? `<div class="tooltip-item">
                    <div class="d-flex align-items-center pre-wrap">
                      <img src="${require("../../assets/google_icon.png")}" width="16" height="16" />
                      <span> Join Google Meet Meeting</span>
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      <a href="${
                    eventData.googleMeetMeetingUrl
                }" target="_blank" class="text-primary text-underline">Click here for teleconference link.</a>
                      <b-button id="copyButtonLink" data-event-link='${
                    eventData.googleMeetMeetingUrl
                }' v-b-tooltip.hover title="Copy link">
                        <i class="far fa-copy" style="width: 16px"></i>
                      </b-button>
                    </div>
                  </div>`
                : ""
            }
            `;
      }

      if (eventData.type.code == "loc") {
        const participant = eventData.episodesOfCare[0];
        return `
            <div class="schedule-event-tooltip-data"></div>
            ${
              eventData.services
                ? `<div class="tooltip-item">
                    <div>
                      <i class="b-fa b-fa-clinic-medical"></i> Level of care
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      ${
                        eventData.services[0]
                          ? eventData.services[0].service.name
                          : ""
                      }
                    </div>
                  </div>`
                : ""
            }
            <div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-user"></i> Patient
              </div>
              <div class="tooltip-value px-2 m-1">
                ${this.formatEocObj(participant.episodeOfCare)}
              </div>
            </div>
            ${this.getBatchesAndAlertTooltip(participant)}
             ${
               !this.selectedLocation
                 ? `<div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-building"></i> Location
              </div>
              <div
                class="tooltip-value px-2 ml-1"
                style="white-space: nowrap;"
              >
                ${eventData.location.name}
              </div>
              <div class="tooltip-value px-2 ml-1">
                ${eventData.location.timeZoneDisplayName}
                </i>
              </div>
            </div>`
                 : ""
             }
            <div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-clock"></i> Date, time and duration
              </div>
              <div class="tooltip-value px-2 m-1">
                ${this.formatDateTimeDuration(
                  eventData.startDateTime,
                  eventData.endDateTime,
                  eventData.allDay
                )}
              </div>
            </div>
            ${
              eventData.users
                ? `<div class="tooltip-item">
                    <div>
                      <i class="b-fa b-fa-user"></i> Provider
                    </div>
                    <div class="tooltip-value px-2 m-1">
                      ${
                        eventData.users[0]
                          ? this.formatUser(eventData.users[0])
                          : "No provider selected"
                      }
                    </div>
                  </div>`
                : ""
            }
            <div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-user"></i> Billable group session hours completed
              </div>
              <div class="tooltip-value px-2 m-1">
                ${Math.round(
                  (eventData.hoursOfGroupSessionCompleted + Number.EPSILON) *
                    100
                ) / 100} out of ${
          eventData.services[0].service.groupSessionsHoursRequiredForBilling
        } hours.
              </div>
            </div>
            ${
              eventData.episodesOfCare[0].linkedDocuments.length > 0
                ? `<div class="tooltip-item">
                <div class="d-flex justify-content-between">
                  <span><i class="fas fa-file-alt"></i> Documents</span>
                </div>
                <div class="tooltip-value m-1">
                 ${eventData.episodesOfCare[0].linkedDocuments
                   .sort((a, b) => a.form.name.localeCompare(b.form.name))
                   .map(formatDocument)
                   .join("")}
                </div>
              </div>
              `
                : ""
            }
            ${billingInfoFormatted}
            `;
      }
    },
    getToolTipServices(eventData) {
      return eventData.services && eventData.services.length
        ? `<div class="tooltip-item">
                    <div>
                      <i class="fas fa-stethoscope"></i> Services
                    </div>
                    ${eventData.services
                      .map(service => {
                        return `
                      <div class="tooltip-value px-2 m-1">
                        ${service.service.name}
                      </div>`;
                      })
                      .join("")}
                  </div>`
        : "";
    },
    getToolTipDocuments(eventData) {
      const participant = eventData.episodesOfCare[0];
      const formatDocument = f => {
        const metadata = JSON.stringify({
          eventId: eventData.id,
          id: f.id,
          formId: f.formId,
          document: f.document
        });

        const dataAttributes = `data-appointment-form='${metadata}'`;

        const cssClass =
          !f.document || f.document.status == "Draft"
            ? "fa fa-clock-o text-danger"
            : f.document.status == "Pending"
            ? "fa fa-clock-o text-warning"
            : "fa fa-check text-success";
        let hasEntryAccess = this.hasCurrentUserDocumentPermission(
          f.formId,
          "hasEntryAccess"
        );
        const linkClasses = hasEntryAccess
          ? "text-primary text-underline"
          : "text-secondary text-none disabled";

        const result = `<i style="font-size: 19px;" class="${cssClass}"></i>
                <a class="${linkClasses} ml-1" href="#" ${dataAttributes}>
                  ${f.form.name}
                </a>
                ${
                  hasEntryAccess
                    ? '<i style="font-size: 19px;" class="fa fa-times text-danger ml-2 hover-pointer"></i>'
                    : ""
                }
                `;

        return `<div class="d-flex w-100 justify-content-start align-items-center">${
          f.isEnabledInScheduleEventLocation || f.document
            ? result
            : `<span class='ml-4'>${f.form.name}</span>`
        }</div>`;
      };
      return `${
        participant.linkedDocuments && participant.linkedDocuments.length
          ? `
              <div class="tooltip-item">
                <div class="d-flex justify-content-between">
                  <span><i class="fas fa-file-alt"></i> Documents</span>
                </div>
                <div class="tooltip-value m-1">
                  ${participant.linkedDocuments
                    .sort((a, b) => a.form.name.localeCompare(b.form.name))
                    .map(formatDocument)
                    .join("")}
                </div>
              </div>
              `
          : ""
      }
            <div>
            <a class="text-primary ml-1" href="#" id="attach-document" data-event-id='${
              eventData.id
            }' data-eoc-id='${
        participant.episodeOfCare.id
      }'>+ Attach document</a>
            </div>`;
    },
    linkAttachForm() {
      const attachLink = document.querySelector("#attach-document");
      if (attachLink) {
        attachLink.onclick = async () => {
          this.selectedForm = null;
          this.selectedDocuments = [];
          this.$dialog
            .alert(
              {
                title: "Attach document to appointment"
              },
              {
                view: "radio-buttons",
                options: [
                  { value: "existing", label: "Existing document" },
                  { value: "new", label: "New document" }
                ],
                defaultValue: "existing"
              }
            )
            .then(dialog => {
              this.selectedScheduleEventId = attachLink.dataset.eventId;
              if (dialog.data === "existing") {
                this.eocId = attachLink.dataset.eocId;
                this.fetchDocsByEOC();
                this.showSubmitDocument = true;
              } else {
                this.showSubmitForm = true;
              }
            });
        };
      }
    },
    linkForms(e) {
      const forms = document.querySelectorAll("a[data-appointment-form]");

      forms.forEach(node => {
        const metadata = JSON.parse(node.dataset.appointmentForm);
        var deleteImg = node.nextElementSibling;
        if (
          this.hasCurrentUserDocumentPermission(
            metadata.formId,
            "hasEntryAccess"
          )
        )
          deleteImg.onclick = () => {
            const preventToolTipCloseListener = async event => {
              const clickedOutside = !e.source.currentElement.contains(
                event.target
              );

              if (clickedOutside) {
                this.forceToShowTooltipInstance(e);
              }
            };

            document.addEventListener("click", preventToolTipCloseListener);

            this.$dialog
              .confirm(
                {
                  title: "Are you sure you want to remove this document?"
                },
                {
                  view: "confirm-delete"
                }
              )
              .then(() => {
                scheduleEventServer.deleteForm(metadata.id).then(() => {
                  node.parentNode.remove();
                  document.removeEventListener("click", preventToolTipCloseListener);
                  this.keepTooltip(e);
                  this.showAlertSuccess();
                });
              })
              .catch(() => null);
          };

        node.onclick = async e => {
          e.preventDefault();
          const scheduleEvent = this.scheduleEvents.find(
            u => u.id == metadata.eventId
          );
          const participant = scheduleEvent.episodesOfCare[0];
          const eoc = participant.episodeOfCare;
          if (!metadata.document) {
            this.form = await this.getFormBuilderFormById(metadata.formId);
            if (
              getFormBuilderComponents(this.form.current.content).length > 0
            ) {
              this.openDocumentAddEdit(
                eoc.id,
                eoc.patient.id,
                metadata.formId,
                metadata.eventId,
                participant.id,
                scheduleEvent.startDateTime
              );
            } else {
              this.openDocumentFileAddEdit(
                eoc.id,
                eoc.patient.id,
                metadata.formId,
                metadata.eventId,
                participant.id,
                scheduleEvent.startDateTime
              );
            }
          } else {
            this.openDocumentViewer(metadata.document);
          }
        };
      });
    }
  },
  computed: {
    ...mapState("layout", {
      sidebarChange: state => state.sidebarChange
    }),
    ...mapGetters("layout", ["datesNonWorking", "canEditChargedEvents"]),
    ...mapGetters("client", ["lowerOperationsStarts", "higherOperationsEnds"]),
    ...mapState("client", {
      statuses: state =>
        state.scheduleEventStatuses.map(status => ({
          value: status.id,
          label: status.name,
          data: {
            ...status,
            backgroundColor: lightenDarkenColor(status.color, 85)
          }
        })),
      locations: state =>
        state.locations.map(location => ({
          value: location.id,
          label: location.name,
          data: location
        })),
      providersPlacesOfService: state =>
        state.placesOfService.map(placeOfService => ({
          value: placeOfService.id,
          label: placeOfService.name,
          data: placeOfService
        }))
    }),
    ...mapState("layout", {
      currentUser: state => state.currentUser,
      assignedToMe: state => state.assignedToMeSchedulerIndex,
      billingRestriction: state => state.systemSetting.restrictDayInLOCBilling,
      tenantName: state => state.systemSetting.currentTenant,
      currentCalendar: state => state.currentCalendarViewIndex,
      signalRAppUrl: state => state.systemSetting.signalRAppUrl,
      enablePaymentSystem: state => state.systemSetting.enablePaymentSystem
    }),
    ...mapGetters("layout", ["getCurrentAdjustedDateTime"]),
    ...mapGetters("client", ["selectedLocation"]),
    ...mapGetters("layout", [
      "hasCurrentUserDocumentPermission",
      "hasCurrentUserReportPermission",
      "hasCurrentUserPermissionAccess"
    ]),
    ...mapGetters("client", ["formsMainAndMasterTreatmentPlanCurrentLocation"]),
    ...mapGetters("formBuilder", ["getFormBuilderFormById"]),
    getHTMLForPoS() {
      const getHour = date => moment(date).format("h:mma");
      const getHourRange = (providerAvailability, providerAvailabilityNumber) =>
        providerAvailabilityNumber > 1
          ? `${getHour(providerAvailability.startDateTime)} - ${getHour(
              providerAvailability.endDateTime
            )}`
          : "";
      const getPlaceOfServiceName = (providerAvailability, trimName) => {
        let name = providerAvailability?.placeOfService?.name ?? "";
        if (trimName && name && name.length > 50)
          name = name.slice(0, 50) + "...";
        return name;
      };
      const getPlaceOfService = (
        providerAvailability,
        providerAvailabilitiesNumber,
        trimName = false
      ) =>
        `<div style=" padding:5px 0 5px 0">
            <i class="fas fa-map-marker-alt"></i>
            <span>${getPlaceOfServiceName(
              providerAvailability,
              trimName
            )} ${getHourRange(
          providerAvailability,
          providerAvailabilitiesNumber
        )}
            </span>
          </div>`;
      const getMorePlaceOfServices = (
        providerAvailabilities,
        providerId,
        providerAvailabilitiesNumber
      ) =>
        providerAvailabilitiesNumber > 1
          ? `<a id="more_provider_availabilities_anchor-${providerId}"
                    href="#" class="more_provider_availabilities_anchor">
                    <i class="fas fa-map-marker-alt"></i> More...
                 </a>
                 <div id="more_provider_availabilities-${providerId}"
                      class="more_provider_availabilities invisible"
                      style="position: absolute; border-style: solid; padding:3px; width:100%;
                          background-color: white; max-height:300px; overflow-y:scroll;">
                   ${providerAvailabilities
                     .slice(1)
                     .map(providerAvailability =>
                       getPlaceOfService(
                         providerAvailability,
                         providerAvailabilitiesNumber
                       )
                     )
                     .join("")}
                 </div>`
          : "";

      return resource => {
        let pa = [...resource.providerAvailabilities];
        let providerAvailabilities = pa?.flatMap(availability => {
          return availability.placesOfService?.map(placeOfService => {
            return { ...availability, placeOfService };
          });
        });
        const providerAvailabilityNumber =
          resource.providerAvailabilities &&
          resource.providerAvailabilities.length > 0
            ? Object.keys(
                providerAvailabilities.reduce((acc, providerAvailability) => {
                  let key = providerAvailability?.placeOfService?.id;
                  acc[key] ??= [];
                  acc[key].push(providerAvailability);
                  return acc;
                }, {})
              ).length
            : 0;

        return providerAvailabilityNumber
          ? getPlaceOfService(
              providerAvailabilities[0],
              providerAvailabilityNumber,
              true
            ) +
              getMorePlaceOfServices(
                providerAvailabilities,
                resource.id,
                providerAvailabilityNumber
              )
          : "";
      };
    },
    getTbar() {
      let tbar = { ...this.tbar };
      if (this.hasCurrentUserReportPermission("Scheduled Events")) {
        tbar.items.export = {
          type: "button",
          text: "Export",
          color: "b-blue b-raised",
          icon: "b-fa b-fa-download",
          cls: "",
          tooltip: "",
          onClick: this.export
        };
      }
      return tbar;
    },
    modes() {
      const dayStartTime =
        this.selectedLocation && this.selectedLocation.operationStarts
          ? this.selectedLocation.operationStarts
          : this.lowerOperationsStarts;
      const dayEndTime =
        this.selectedLocation && this.selectedLocation.operationEnds
          ? this.selectedLocation.operationEnds
          : this.higherOperationsEnds;
      return {
        agenda: null,
        day: {
          hourHeight: 80,
          // allDayEvents: {
          //   fullWeek: false
          // },
          dayStartTime: dayStartTime,
          dayEndTime: dayEndTime,
          eventRenderer: this.eventRenderer
        },
        week: {
          hourHeight: 80,
          dayStartTime: dayStartTime,
          dayEndTime: dayEndTime,
          eventRenderer: this.eventRenderer
        },
        month: {
          eventRenderer: this.monthEventRenderer
        },
        year: false,
        byProvider: {
          type: "resource",
          title: "By Provider",
          resourceWidth: "15em",
          cls: "resource-provider",
          view: {
            type: "day",
            // allDayEvents: {
            //   fullWeek: false
            // },
            hourHeight: 80,
            eventRenderer: this.eventRenderer,
            dayStartTime: dayStartTime,
            dayEndTime: dayEndTime
          }
        }
      };
    },
    calendarDate() {
      return moment(this.date).toDate();
    },
    calendarEvents: {
      get() {
        const events = [];
        const appointments = this.scheduleEvents.filter(
          u => u.type.code === "appointment"
        );
        for (let index = 0; index < appointments.length; index++) {
          const now = this.getCurrentAdjustedDateTime();
          const appointment = appointments[index];
          if (appointment.episodesOfCare.length > 0) {
            const startDate = moment(appointment.startDateTime).toDate();
            let endDate;
            if (appointment.allDay) {
              endDate = moment(startDate).add(1, "days");
            } else {
              const endOfDay = moment(appointment.startDateTime).endOf("day");
              endDate = moment(appointment.endDateTime);

              if (endDate > endOfDay) {
                endDate = endOfDay;
              }
            }
            let eventColor = "";
            if (
              appointment.episodesOfCare[0].scheduleEventStatus.code == "show"
            ) {
              const serviceAppoiments = appointment.services.filter(
                serviceAppoiment =>
                  serviceAppoiment.service.color !== undefined &&
                  serviceAppoiment.service.color !== null &&
                  serviceAppoiment.service.color !== "white"
              );
              if (serviceAppoiments && serviceAppoiments.length > 0)
                eventColor = serviceAppoiments[0].service.color;
              else if (startDate > now) {
                eventColor = "#1E50B3";
              } else {
                appointment.episodesOfCare[0].scheduleEventStatus.color;
              }
            } else {
              eventColor =
                appointment.episodesOfCare[0].scheduleEventStatus.color;
            }

            events.push({
              eventData: appointment,
              startDate: moment(appointment.startDateTime).toDate(),
              eventColor: eventColor,
              endDate: endDate.toDate(),
              name: `${this.formatClient(
                appointment.episodesOfCare[0].episodeOfCare.patient.firstName,
                appointment.episodesOfCare[0].episodeOfCare.patient.middleName,
                appointment.episodesOfCare[0].episodeOfCare.patient
                  .preferredName,
                appointment.episodesOfCare[0].episodeOfCare.patient.lastName
              )}`,
              resourceId:
                appointment.users.length > 0 ? appointment.users[0].id : -1,
              iconCls: ""
            });
          }
        }

        const groupSessions = this.scheduleEvents.filter(
          u => u.type.code === "groupSession"
        );
        for (let index = 0; index < groupSessions.length; index++) {
          const group = groupSessions[index];
          const now = this.getCurrentAdjustedDateTime();
          const startDate = moment(group.startDateTime).toDate();
          let endDate;
          if (group.allDay) {
            endDate = moment(startDate).add(1, "days");
          } else {
            const endOfDay = moment(group.startDateTime).endOf("day");
            endDate = moment(group.endDateTime);

            if (endDate > endOfDay) {
              endDate = endOfDay;
            }
          }
          let eventColor = "";
          const servicesGroup = group.services.filter(
            serviceGroup =>
              serviceGroup.service.color !== undefined &&
              serviceGroup.service.color !== null &&
              serviceGroup.service.color !== "white"
          );
          if (servicesGroup && servicesGroup.length > 0)
            eventColor = servicesGroup[0].service.color;
          else if (startDate > now) {
            eventColor = "#1E50B3";
          } else {
            eventColor = "#66C854";
          }

          events.push({
            eventData: group,
            startDate: moment(group.startDateTime).toDate(),
            eventColor: eventColor,
            endDate: endDate.toDate(),
            name: "Group Session",
            resourceId: group.users.length > 0 ? group.users[0].id : -1,
            iconCls: ""
          });
        }

        const others = this.scheduleEvents.filter(u => u.type.code === "other");
        for (let index = 0; index < others.length; index++) {
          const other = others[index];
          const startDate = moment(other.startDateTime).toDate();
          let endDate;
          if (other.allDay) {
            endDate = moment(startDate).add(1, "days");
          } else {
            const endOfDay = moment(other.startDateTime).endOf("day");
            endDate = moment(other.endDateTime);

            if (endDate > endOfDay) {
              endDate = endOfDay;
            }
          }
          if (this.isByProviderViewActive) {
            for (let i = 0; i < other.users?.length; i++) {
              const user = other.users[i];
              events.push({
                eventData: other,
                startDate: moment(other.startDateTime).toDate(),
                eventColor: "#e53f2c",
                endDate: endDate.toDate(),
                name: other.title,
                resourceId: user.id ?? -1,
                iconCls: ""
              });
            }
          } else {
            events.push({
              eventData: other,
              startDate: moment(other.startDateTime).toDate(),
              eventColor: "#e53f2c",
              endDate: endDate.toDate(),
              name: other.title,
              resourceId: null,
              iconCls: ""
            });
          }
        }

        const locs = this.scheduleEvents.filter(u => u.type.code === "loc");
        for (let index = 0; index < locs.length; index++) {
          const loc = locs[index];
          const startDate = moment(loc.startDateTime).toDate();
          let endDate = moment(startDate).add(1, "days");

          events.push({
            eventData: loc,
            startDate: moment(loc.startDateTime).toDate(),
            eventColor: "#4044E6",
            endDate: endDate.toDate(),
            name:
              loc.episodesOfCare.length > 0
                ? this.formatEocObj(loc.episodesOfCare[0].episodeOfCare)
                : "",
            resourceId: loc.users.length > 0 ? loc.users[0].id : -1,
            iconCls: ""
          });
        }
        if (!this.isMonthViewActive) {
          var notAvailableTimes = this.getNonAvailableTimes();
          for (let index = 0; index < notAvailableTimes.length; index++) {
            const nonAvailability = notAvailableTimes[index];
            events.push({
              eventData: {
                ...nonAvailability,
                type: {
                  code: "nonAvailability"
                }
              },
              startDate: moment(nonAvailability.startDateTime).toDate(),
              eventColor: "#A8ADB3",
              endDate: nonAvailability.endDateTime,
              readOnly: true,
              resourceId: nonAvailability.providerId,
              cls: "non-availability"
            });
          }
        }
        const appointmentRequests = this.appointmentRequests
          .appointmentRequests;
        appointmentRequests?.forEach(appointmentRequest => {
          const startDate = moment(appointmentRequest.startDateTime).toDate();
          let endDate;
          if (appointmentRequest.allDay) {
            endDate = moment(startDate)
              .add(1, "days")
              .toDate();
          } else {
            const endOfDay = moment(appointmentRequest.startDateTime)
              .endOf("day")
              .toDate();
            endDate = moment(appointmentRequest.endDateTime).toDate();

            if (endDate > endOfDay) {
              endDate = endOfDay;
            }
          }
          events.push({
            eventData: {
              ...appointmentRequest,
              type: {
                code: "appointmentRequest"
              }
            },
            startDate: startDate,
            endDate: endDate,
            eventColor: "#eb3434",
            name: `${appointmentRequest.firstName ??
              ""} ${appointmentRequest.middleName ??
              ""} ${appointmentRequest.lastName ?? ""}`,
            resourceId: appointmentRequest.provider
              ? appointmentRequest.provider.id
              : -1,
            iconCls: "",
            cls: "appointment-request",
            readOnly: true
          });
        });
        if (events.length === 0) {
          events.push({ resourceId: -1 });
        }

        return events;
      }
    },
    modeDefaults: {
      get() {
        return {
          view: {
            strips: {
              resourceInfo: {
                type: "widget",
                dock: "header",
                cls: "b-resource-meta",
                floating: true,
                html: widget => {
                  return `<div id="container-for-pos_${widget.owner.resource?.id}"
                               class="place-of-service-widget"
                          ></div>`;
                }
              }
            }
          }
        };
      }
    },
    calendarResources: {
      get() {
        let resources = [];
        const providerAvailabilitiesOfToday = this.providerAvailabilities.filter(
          pa => this.formatDateOnlyMysql(pa.startDateTime) == this.date
        );

        this.providerList
          .filter((provider, providerIndex) => {
            return providerIndex < this.providersPage * this.providersPageSize;
          })
          .forEach(user => {
            const providerAvailabilitiesOfTodayByUser = providerAvailabilitiesOfToday.filter(
              pa => pa.provider.id === user.data.id
            );
            if (!resources.find(item => item.id === user.data.id)) {
              resources.push({
                name: user.data.firstName + ` ` + user.data.lastName,
                imageUrl: user.data.avatarId
                  ? avatarServer.avatarUrl(user.data.avatarId)
                  : require(`../../assets/avatar-example.png`),
                id: user.data.id,
                providerAvailabilities: providerAvailabilitiesOfTodayByUser
              });
            }
          });
        resources.sort((a, b) => {
          const nameA = a.name.toUpperCase();
          const nameB = b.name.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
        if (resources.length === 0) {
          resources.push({
            name: "No Provider",
            imageUrl: require(`../../assets/avatar-example.png`),
            id: -1
          });
        }
        if (
          this.providersPage * this.providersPageSize <
          this.providerList.length
        ) {
          resources.push({
            name: "Load More",
            imageUrl: require(`../../assets/avatar-example.png`),
            cls: "load-more-providers",
            id: -2
          });
        }

        return resources;
      }
    },
    providerUsers() {
      return this.users.filter(u => u.data.providerInfo);
    },
    providerList() {
      return this.anyProviderFilter || this.filter.users?.data
        ? this.providers
        : this.providerUsers;
    },
    anyProviderFilter() {
      return this.providerFilterEnabled || this.scheduleFilterEnabled;
    },
    providerFilterEnabled() {
      return (
        this.filter.providersPlacesOfService?.length > 0 ||
        this.filter.insuranceCompanies?.length > 0 ||
        this.filter.providersServices?.length > 0
      );
    },
    scheduleFilterEnabled() {
      return (
        this.filter.documentationStatus?.length > 0 ||
        this.filter.facilitators?.length > 0 ||
        this.filter.services?.length > 0 ||
        this.filter.status?.length > 0 ||
        this.filter.rooms?.length > 0 ||
        this.filter.eocs?.length > 0
      );
    },
    providerFacilitators() {
      return this.users.filter(u => u.data.providerInfo);
    },
    exportFilter() {
      return {
        patientIds: this.filter.eocs.map(x => x.value),
        userIds:
          this.filter.users && this.filter.users.value
            ? [this.filter.users.value]
            : [],
        FacilitatorIds: this.filter.facilitators.map(x => x.value),
        locationIds: this.selectedLocation
          ? [this.selectedLocation?.id]
          : [this.filter.locations.map(location => location.value)],
        roomIds: this.filter.rooms.map(x => x.value),
        statusDocumentValue: this.filter.documentationStatus
          ? this.filter.documentationStatus.map(x => (x == "Completed" ? 1 : 0))
          : [],
        statusIds: this.filter.status,
        serviceIds: this.filter.services.map(x => x.value),
        dateFrom: this.filter.startDate,
        dateTo: this.filter.endDate,
        assignedToMe: this.assignedToMe
      };
    },
    formOptions() {
      const forms = this.formsMainAndMasterTreatmentPlanCurrentLocation
        .filter(form =>
          this.hasCurrentUserDocumentPermission(form.id, "hasEntryAccess")
        )
        .map(form => ({
          value: form.id,
          label: form.name
        }));

      return [...forms].sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );
    },
    selectedDocumentsComputed: {
      get() {
        return this.selectedDocuments.map(d => ({
          documentId: d,
          readonly: true
        }));
      },
      set(newValue) {
        this.selectedDocuments = newValue.map(d => d.documentId);
      }
    }
  },
  watch: {
    showSubmitForm: function(newValue) {
      if (!newValue) {
        this.selectedDocType = "standard";
      }
    },
    showing: {
      handler: async function(newValue) {
        if (newValue) {
          this.providersPage = 1;
          this.providersPageSize = 10;
          await this.fetchInitialData();
          this.fetchDocsByEOC("", 0);
        }
      },
      immediate: true
    },
    "filter.eocs": function() {
      this.fetchData();
    },
    "filter.users": function() {
      if (this.showing) {
        this.fetchData();
        this.fetchProviderAvailabilities();
      }
    },
    "filter.facilitators": function() {
      this.fetchData();
    },
    "filter.status": function() {
      this.fetchData();
    },
    "filter.services": function() {
      this.fetchData();
    },
    "filter.documentationStatus": function() {
      this.fetchData();
    },
    "filter.rooms": function() {
      this.fetchData();
    },
    "filter.insuranceCompanies": function() {
      this.fetchData();
    },
    "filter.providersServices": function() {
      this.fetchData();
    },
    "filter.providersPlacesOfService": function() {
      this.fetchData();
    },
    "filter.locations": function() {
      this.fetchData();
    },
    "filter.placeOfService": function() {
      this.fetchData();
    },
    calendarResources: function() {
      this.insertPlaceOfService();
      this.insertLoadMoreLogic();
    },
    sidebarChange: function(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.extraModuleWidth = getSidebarCollapsed() ? 180 : 0;
        }, 500);
      }
    }
  }
};
</script>

<style scoped>
#scheduled-event-calendar-view >>> .non-availability {
  pointer-events: none;
  cursor: default !important;
  z-index: 0 !important;
  opacity: 0.7 !important;
  background-color: #a8adb3 !important;
  width: 100% !important;
  left: 0 !important;
}

#scheduled-event-calendar-view >>> .appointment-request {
  pointer-events: none;
  cursor: default !important;
  opacity: 0.7 !important;
  background-color: #a8adb3 !important;
}

#scheduled-event-calendar-view >>> .appointment-request {
  opacity: 1 !important;
  background-color: inherit !important;
}
#scheduled-event-calendar-view
  >>> .appointment-request.b-cal-event-wrap.b-readonly
  .b-event-header,
#scheduled-event-calendar-view
  >>> .appointment-request.b-cal-event-wrap.b-readonly
  .b-cal-event-desc {
  opacity: 1 !important;
}
#scheduled-event-calendar-view >>> .b-readonly .b-cal-event-body {
  background-color: rgba(255, 255, 255, 0.9) !important;
}
#scheduled-event-calendar-view
  >>> .appointment-request.b-readonly.b-intraday
  .b-cal-event-body {
  background-color: transparent !important;
}
.container-calendar >>> .b-resourceview-content {
  max-width: calc(100vw - 523px + var(--extra-module-width));
}

.container-calendar {
  box-shadow: inset 0px 16px 10px -16px rgb(0 0 0 / 75%);
}

#scheduled-event-calendar-view {
  height: calc(100vh - 50px);
}

.sidebar-filters-container {
  max-height: calc(100vh - 298px);
  min-height: calc(100vh - 298px);
  overflow-y: auto;
  overflow-x: hidden;
  margin-left: -20px;
  padding-left: 10px;
  padding-bottom: 120px;
}

.divider {
  margin: 10px 8px 10px -19px;
}

.calendar-container {
  text-align: center;
}

.event-type-container {
  margin: 0px 10px;
}

.event-type-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 30px;
}

.event-type-label {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.event-type-label-item {
  font-size: 13px;
  padding-top: 3px;
}

.box-color {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}

.box-color-red {
  background-color: red;
}

.box-color-yellow {
  background-color: yellow;
}

.filter-container {
  float: left;
  width: 240px;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  display: flex;
  overflow: auto;
  transition: width 0.5s;
  overflow-x: hidden;
}

.filter-container-inner {
  width: 250px;
  padding: 0px;
}

.participants-container {
  margin: 0px 10px;
}

.add-event-container {
  text-align: center;
}

.filter-label {
  font-size: 0.9rem;
  font-weight: 400;
}

.filter-container-hidden {
  width: 0px !important;
}

.main-bar {
  background-color: #0062cc;
  padding: 5px 10px;
  flex-direction: row;
  justify-content: space-between;
  display: flex;
  align-items: center;
  color: white;
}

.main-bar-left {
  flex-direction: row;
  justify-content: flex-start;
  display: flex;
  align-items: center;
}

.icon-img {
  height: 40px;
  width: 40px;
}

.toggle-sidebar:hover {
  cursor: pointer;
}

.filter-icon {
  transition: transform 0.5s;
}
.filter-icon-rotate {
  transform: rotate(90deg);
}

.event-type-label-text {
  font-size: 13px;
}
</style>
<style>
#scheduled-event-calendar-view .calendar-content .b-calendar-days {
  min-height: 85px;
}

#scheduled-event-calendar-view .b-grid-header-resizable {
  background-color: #0062cc;
  color: white;
  align-items: center;
}

#scheduled-event-calendar-view .b-grid-header-resizable:hover {
  background-color: #0062cc !important;
}

#scheduled-event-calendar-view .b-calendar {
  display: initial !important;
}

#scheduled-event-calendar-view .b-sidebar {
  display: initial !important;
  position: initial !important;
  width: initial !important;
}

#scheduled-event-calendar-view .b-calendar .b-calendar-content {
  height: calc(100vh - 150px) !important;
}

#scheduled-event-calendar-view .b-float-root {
  z-index: 10 !important;
}

#scheduled-event-calendar-view .b-calendar .b-calendar-inner .font-weight-bold {
  font-weight: 400 !important;
  font-size: 15px;
}

#scheduled-event-calendar-view .b-calendar .b-calendar-inner .text-muted {
  color: #d8d8d8 !important;
}

#scheduled-event-calendar-view .b-calendar-nav {
  position: relative;
}

#scheduled-event-calendar-view .b-calendar-nav button {
  display: none !important;
}

#scheduled-event-calendar-view .b-calendar-nav button:nth-child(2) {
  display: block !important;
  flex: none !important;
  position: absolute;
  right: 30px;
  top: 5px;
}

#scheduled-event-calendar-view .b-calendar-nav button:nth-child(4) {
  display: block !important;
  flex: none !important;
  position: absolute;
  right: 0px;
  top: 5px;
}

#scheduled-event-calendar-view .b-calendar-grid-weekdays.border-bottom {
  border-bottom: none !important;
}

#scheduled-event-calendar-view .b-calendar .b-calendar-inner .font-weight-bold {
  font-weight: 400 !important;
}

#scheduled-event-calendar-view .b-calendar .b-calendar-inner .text-muted {
  color: #d8d8d8 !important;
}

#scheduled-event-calendar-view .b-calendar-grid-help {
  display: none;
}

#scheduled-event-calendar-view .b-calendar .b-calendar-grid {
  border: none;
}

#scheduled-event-calendar-view .b-calendar-grid-caption.text-center {
  text-align: left !important;
}

#scheduled-event-calendar-view .b-calendar .b-calendar-grid {
  background-color: transparent !important;
}

#scheduled-event-calendar-view .b-calendar > .b-top-toolbar {
  background-color: #f5f8fc !important;
}

#scheduled-event-calendar-view label {
  margin-bottom: 0px !important;
}

#scheduled-event-calendar-view .font-size-icon::before {
  font-size: 17px !important;
}

#scheduled-event-calendar-view .little-badge {
  font-size: 11px;
}

#scheduled-event-calendar-view {
  -webkit-user-select: none; /* Safari */
  -webkit-touch-callout: none; /* iOS Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                   supported by Chrome, Edge, Opera and Firefox */
}
.more_provider_availabilities.invisible {
  display: none;
}
#scheduled-event-calendar-view
  .b-calendar
  .b-calendar-grid-body
  .col[data-date]
  .btn,
#scheduled-event-calendar-view .b-calendar-grid-weekdays.border-bottom small {
  font-size: 12px !important;
}

#scheduled-event-calendar-view .form-group legend {
  font-size: 13px !important;
  color: #495057;
}

#scheduled-event-calendar-view .b-calendar-week > .b-calendar-cell {
  display: none !important;
}

.calendar-content .event-name-label {
  font-size: 13px;
}

.calendar-content .b-weekview .b-event-header,
.calendar-content .b-dayview .b-event-header {
  display: none;
}

.calendar-content .b-calendarrow .b-cal-cell-header {
  padding-top: 10px !important;
}

.calendar-content .b-calendarrow .b-cal-cell-header .b-day-name-date {
  font-size: 1.5em;
}
.calendar-content .resource-provider .b-calendarrow .b-cal-cell-header {
  pointer-events: none;
}
.calendar-content .b-dayview-day-container .b-calendar-cell .b-cal-event-body {
  padding: 1px 0px 0px 5px !important;
}

.calendar-content .b-calendar-view-desc {
  margin-left: 0px !important;
}

.calendar-content .b-toolbar.b-dock-top,
.b-toolbar.b-dock-bottom {
  min-height: 3.2em;
}

.container-calendar .vs__dropdown-menu {
  max-height: 150px !important;
}

.container-calendar .items-list-container {
  max-height: 165px !important;
}

.hide-sibling-notes .custom-icon-notes {
  display: none;
}
.hide-sibling-notes .custom-icon-notes-prod {
  display: none;
}

.hide-sibling-view .custom-icon-view {
  display: none;
}
.hide-sibling-view .custom-icon-view-prod {
  display: none;
}

.hide-sibling-doc-req-and-sharing .custom-icon-doc-request {
  display: none;
}
.hide-sibling-doc-req-and-sharing .custom-icon-doc-request-prod {
  display: none;
}

.hide-sibling-follow-up .custom-icon-follow-up {
  display: none;
}
.hide-sibling-follow-up .custom-icon-follow-up-prod {
  display: none;
}

.hide-sibling-edit .custom-icon-edit {
  display: none;
}
.hide-sibling-edit .custom-icon-edit-prod {
  display: none;
}

.hide-sibling-delete .custom-icon-delete {
  display: none;
}
.hide-sibling-delete .custom-icon-delete-prod {
  display: none;
}

.color-box {
  background-color: red;
  color: white;
  padding: 2px;
  border-radius: 35px;
  min-width: 24px;
  min-height: 24px;
  margin-right: 5px;
  text-align: center;
}

.custom-control-inline {
  margin-right: 0px !important;
}

.b-sch-event {
  flex-wrap: wrap;
  align-content: flex-start;
}

.b-panel-header.b-dock-top {
  border-bottom: none;
}

.b-popup-header {
  background-color: #f6f6f6;
}

.b-panel-header .b-header-title {
  font-size: 16px;
}

.b-panel-header {
  padding: 5px 10px;
}

.b-tooltip-content {
  padding: 5px 10px;
}

.b-popup.b-sch-event-tooltip {
  width: 25rem;
  margin: 0px;
}

.tooltip-participants-container {
  background-color: #f6f6f6;
  margin: 0px !important;
}

.tooltip-participants-container .col-sm-6 {
  padding: 0px 5px !important;
}

.grey-circle {
  min-width: 10px;
  min-height: 10px;
  background-color: #d0d0d0;
  margin-right: 5px;
  border-radius: 10px;
  margin-top: 5px;
}

.participant-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}

.tooltip-value {
  font-size: 14px;
}

.tooltip-value-right {
  align-self: right;
}

.tooltip-item {
  margin-top: 10px;
}

.tooltip-footer {
  text-align: center;
}

.tooltip-item-calendar {
  display: none;
}

.copy-link-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.b-grid-header-text {
  font-size: 14.4px;
}

.vs__deselect {
  margin-left: 5px !important;
}

.small-selector {
  font-size: 13px;
}

.ml--10 {
  margin-left: -10px;
}

.modal >>> .modal-attach-doc {
  max-width: 850px !important;
}

.b-resource-name {
  position: absolute;
  left: 60px;
  top: 16px;
}

.place-of-service-widget {
  font-size: 10px;
  white-space: normal;
  word-break: break-all;
  position: absolute;
  top: 36px;
  left: 60px;
  max-width: 260px;
}
#copyButtonLink:hover {
  color: #2196f3;
}
</style>
